/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Null */
export type Null = string | null;

/** Error */
export interface Error {
  code: number;
  message: string;
  /** Model validation errors. Normally present if the code is 1000. */
  validations?: ValidationErrors;
  /** @example ["Email is invalid","Name can't be blank"] */
  validation_messages?: string[];
  /** @example [10000,10001,10020] */
  validation_codes?: number[];
}

/**
 * Validation Errors
 * Model validation errors. Normally present if the code is 1000.
 * @example {"base":["User not found"],"name":["has already been taken"],"url":["is invalid","is not unique"]}
 */
export type ValidationErrors = Record<string, string[]>;

export interface Attachment {
  id: number;
  content_type: string;
  filename: string;
  /** Original file */
  url: string;
  created_at: string;
}

export interface Screenshot {
  id: number;
  content_type: string;
  filename: string;
  /** Original file */
  url: string;
  /** A small 150px-height thumbnail */
  thumb: string;
  /** A slightly larger 600px-height preview */
  preview: string;
  created_at: string;
}

export interface Icon {
  id: number;
  content_type: string;
  filename: string;
  /** Original file */
  url: string;
  /** 16px square icon */
  "1x": string;
  /** 32px square icon */
  "2x": string;
  /** 96px square icon */
  "6x": string;
  /** 128px square icon */
  "8x": string;
  created_at: string;
}

export interface Registration {
  /**
   * @format email
   * @example "john.doe+1@example.com"
   */
  email: string;
  /** @example "John" */
  first_name: string;
  /** @example "Doe" */
  last_name: string;
  /**
   * @format password
   * @example "Test1234"
   */
  password: string;
  /**
   * @format password
   * @example "Test1234"
   */
  password_confirmation: string;
  /**
   * If present in the URL, should be copied into the payload.
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  subscription_uuid?: string;
  /**
   * If accepting an invitation, should be copied to the payload.
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  invitation_uuid?: string;
  /** If present in the URL, should be copied into the registration POST payload. */
  utm_campaign?: string;
  /** If present in the URL, should be copied into the registration POST payload. */
  utm_content?: string;
  /** If present in the URL, should be copied into the registration POST payload. */
  utm_medium?: string;
  /** If present in the URL, should be copied into the registration POST payload. */
  utm_source?: string;
  /** If present in the URL, should be copied into the registration POST payload. */
  utm_term?: string;
  /** If present in the URL, should be copied into the registration POST payload. */
  ref?: string;
}

export interface SubscriptionLinkRegistration {
  /**
   * Replaces the link's email, e.g. when it is taken. Ignored with google_code.
   * @format email
   * @example "john.doe@example.com"
   */
  email?: string;
  /**
   * Optional with google_code when Google supplies a name.
   * @example "John"
   */
  first_name?: string;
  /**
   * Optional with google_code when Google supplies a name.
   * @example "Doe"
   */
  last_name?: string;
  /**
   * Required unless google_code is given.
   * @format password
   * @example "Test1234"
   */
  password?: string;
  /** Google OAuth code; the account takes its email from Google and gets a Google identity. */
  google_code?: string;
}

export interface RegistrationConfirmation {
  confirmation_token: string;
}

export interface RegistrationRequest {
  /** @format email */
  email: string;
}

export interface PasswordRequest {
  /** @format email */
  email: string;
}

export interface PasswordReset {
  reset_password_token: string;
  /** @format password */
  password: string;
  /** @format password */
  password_confirmation: string;
}

export interface Session {
  /** @format email */
  email: string;
  /** @format password */
  password: string;
}

export interface AccessToken {
  id: number;
  key: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  never_used: boolean;
  impersonated?: boolean;
}

export type AccessTokens = AccessToken[];

export interface CurrentSession {
  /**
   * When the current session passed the MFA challenge.
   * @format date-time
   */
  mfa_passed_at?: string | null;
  /** Whether the current session must pass the MFA challenge before accessing protected resources. */
  mfa_required: boolean;
}

export type Mfa =
  | {
      /** MFA is not enabled yet. */
      enrolled: false;
      /** URI to render as a QR code in the authenticator app. */
      provisioning_uri: string;
    }
  | {
      /** MFA is currently enabled. */
      enrolled: true;
      /** Number of unused backup codes left. */
      backup_codes_remaining: number;
    };

export interface MfaOtp {
  /**
   * A single 6-digit TOTP code or a one-time backup code.
   * @example "123456"
   */
  otp_attempt: string;
}

export interface MfaPassword {
  /** @format password */
  current_password: string;
}

export interface MfaEnrollment {
  /** One-time backup codes. Returned exactly once, when MFA is being enabled. Store them in a safe place — they cannot be retrieved again. */
  backup_codes: string[];
  current_session: CurrentSession;
}

export interface UnlockConfirm {
  unlock_token: string;
}

export interface DemoLoginConfirm {
  login_token: string;
}

/**
 * CollectionActions
 * A comma-separated list of actions to authorize
 * @example "index, create"
 */
export type CollectionActions = string;

/**
 * MemberActions
 * A comma-separated list of actions to authorize
 * @example "show, update, destroy"
 */
export type MemberActions = string;

export type PageType =
  | "unknown"
  | "unidentified"
  | "article"
  | "event"
  | "faq"
  | "organization"
  | "person"
  | "product"
  | "video"
  | "job"
  | "contact";

/** @example ["unknown","unidentified","article","event","faq","organization","person","product","video","job","contact"] */
export type PageTypes = PageType[];

export interface Region {
  /** @example ".com" */
  tld?: string;
  /** @example "United States" */
  name?: string;
  /** @example "flags-small/com.png" */
  flag?: string;
}

/** @example {"google.com":{"tld":".com","name":"United States / Global","flag":"flags-small/com.png"},"google.de":{"tld":".de","name":"Germany","flag":"flags-small/de.png"}} */
export type Regions = Record<string, Region>;

/** @example {"en":"English","de":"German"} */
export type Languages = Record<string, string>;

export interface Location {
  id?: number;
  /** @example "State" */
  kind?:
    | "Autonomous Community"
    | "Canton"
    | "City"
    | "Congressional District"
    | "Country"
    | "County"
    | "Department"
    | "Governorate"
    | "Municipality"
    | "Prefecture"
    | "Province"
    | "Region"
    | "State"
    | "Territory"
    | "Union Territory";
  /** @example "New York,United States" */
  name?: string;
  /** @example "US" */
  country_iso_code?: string;
  /** @example 2 */
  level?: number;
  /** @example false */
  stale?: boolean;
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  updated_at?: string;
}

export type Locations = Location[];

/** @example [1,2,3] */
export type Ids = number[];

/** @example ["one","two","three"] */
export type Tags = string[];

/** @example [["example.com.",300,"A","255.255.255.255"],["www.example.com.",300,"A","255.255.255.255"]] */
export type DnsConfig = DnsRecord[];

/**
 * @maxItems 4
 * @minItems 4
 * @example ["example.com.",300,"A","255.255.255.255"]
 */
export type DnsRecord = (string | number)[];

export type ZoneImportErrors = ZoneImportError[];

export interface ZoneImportError {
  line: number;
  text: string;
  message: string;
}

export interface ZoneImport {
  zone: DnsConfig;
  errors: ZoneImportErrors;
}

/** Usage limits, including limits solely from the Plan. */
export interface MetricsPlanLimits {
  /** Maximum number of Team Members allowed by the Plan */
  membership_max: number;
  /** Maximum number of Sites allowed by the Plan */
  site_max: number;
  /** Maximum number of Pages allowed by the Plan */
  page_max: number;
  /** Maximum number of Keywords allowed by the Plan */
  keyword_max: number;
}

/** Usage limits, including limits from the Plan and AddOns. */
export interface MetricsTeamLimits {
  /** Maximum number of Team Members allowed by the Plan AND Add-Ons */
  membership_max: number;
  /** Maximum number of Sites allowed by the Plan AND Add-Ons */
  site_max: number;
  /** Maximum number of Pages allowed by the Plan AND Add-Ons */
  page_max: number;
  /** Maximum number of Keywords allowed by the Plan AND Add-Ons */
  keyword_max: number;
}

/** Free credits. */
export interface MetricsFreeLimits {
  /** Number of Page Crawls included for free. */
  page_optimization: number;
  /** Number of Keyword Rank Updates included for free. */
  keyword_rank: number;
  /** Number of JSON-LD Schemas included for free. */
  ai_page_schema: number;
  /** Number of Page Meta Titles included for free. */
  ai_meta_title: number;
  /** Number of Page Meta Descriptions included for free. */
  ai_meta_description: number;
}

/** Already logged usage during the current billing cycle. */
export interface MetricsCurrentUsage {
  /** Current number of Team Members */
  membership_max: number;
  /** Current number of Sites */
  site_max: number;
  /** Current number of Pages */
  page_max: number;
  /** Current number of Keywords */
  keyword_max: number;
  /** Number of Page Crawls over the current billing period. */
  page_optimization: number;
  /** Number of Keyword Rank Updates over the current billing period. */
  keyword_rank: number;
  /** Number of JSON-LD Schemas generated and serving over the current billing cycle. */
  ai_page_schema: number;
  /** Number of Page Meta Titles generated and serving over the current billing cycle. */
  ai_meta_title: number;
  /** Number of Page Meta Descriptions generated and serving over the current billing cycle. */
  ai_meta_description: number;
}

/** Estimated planned usage till the end of the current billing cycle. */
export interface MetricsEstimatedUsage {
  /** Number of Page Crawls estimated to happen in the current billing cycle and condidering crawl interval settings on Sites. */
  page_optimization: number;
  /** Number of Keyword Rank Updates estimated to happen in the current billing cycle and condidering refresh interval settings on Keywords. */
  keyword_rank: number;
}

export interface PaymentsMethodsUsBankAccount {
  /** @example "individual" */
  account_holder_type: string;
  /** @example "checking" */
  account_type: string;
  /** @example "EVOLVE BANK AND TRUST" */
  bank_name: string;
  /** @example "1234" */
  last4: string;
  networks: {
    /** @example "ach" */
    preferred: string | null;
    /** @example ["ach","us_domestic_wire"] */
    supported: string[];
  };
  /** @example "0807060504" */
  routing_number: string;
}

export interface PaymentsMethodsCard {
  /** @example "visa" */
  brand: string;
  checks: {
    /** @example "pass" */
    address_line1_check: string;
    /** @example "pass" */
    address_postal_code_check: string;
    /** @example "fail" */
    cvc_check: string;
  };
  /** @example "US" */
  country: string;
  /** @example "visa" */
  display_brand: string;
  /** @example 12 */
  exp_month: number;
  /** @example 2035 */
  exp_year: number;
  /** @example "credit" */
  funding: string;
  /** @example "1234" */
  last4: string;
  networks: {
    /** @example ["visa"] */
    available: string[];
    /** @example "visa" */
    preferred: string | null;
  };
  three_d_secure_usage: {
    /** @example true */
    supported: boolean;
  };
}

export interface PaymentsPrice {
  id: number;
  product_id: number;
  /** Generation of the Price. Products and Prices in a subscription always are from a single generation. */
  gen: number;
  /**
   * For plan prices, defines the product TIER. For add-on prices, specifies the tier an add-on many apply to.
   * @example "business"
   */
  tier: string;
  /** Some prices may charge just once, some are recirring (e.g. monthly/annual/custom) */
  kind: "one_time" | "recurring";
  name: string;
  size: string | null;
  label: string;
  currency: string;
  billing_scheme: "per_unit" | "tiered";
  recurring_interval: "month" | "year" | "custom" | null;
  /**
   * Price in cents
   * @format float
   * @example "999.0"
   */
  amount: number;
  /**
   * Batch size, e.g. some Add-Ons sell goods in batches like 500 pages, etc.
   * @example 1
   */
  divide_by?: number | null;
  /** The price is active and can be used for new subscriptions. */
  active: boolean;
  /** The price is visible on the marketing website. */
  published: boolean;
  /** If billing scheme eq tiered. */
  tiered: boolean;
  /** Licensed usage type. */
  licensed: boolean;
  /** Opposite to Licensed. */
  metered: boolean;
  /** Applies to Add-Ons, tells whether addon allows changing the quantity or is it a singleton, e.g. an Add-On to enable a feature is always a singleton. */
  quantable: boolean;
  /** Metered prices accept 0 as the initial value. Licensed prices require the quantity from 1 to 999. Licensed singletons can only accept 1. */
  default_quantity: number;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  alternative_ids?: number[] | null;
  best_match_id?: number | null;
  worst_match_id?: number | null;
  recurring: PaymentsPriceRecurring;
  tiers: PaymentsPriceTiers;
  product?: PaymentsProduct;
}

export type PaymentsPrices = PaymentsPrice[];

export interface PaymentsProduct {
  id: number;
  /** Generation of the Price. Products and Prices in a subscription always are from a single generation. */
  gen: number;
  kind: "unknown" | "plan" | "add-on" | "product";
  template:
    | "generic"
    | "brand"
    | "niche"
    | "outreach"
    | "concierge"
    | "llm_citations"
    | "community";
  key: string | null;
  /**
   * Defines a Plan tier, such as business or enterprise. Used to select compatible Add-Ons when creating a new Subscription.
   * @example "business"
   */
  tier: string;
  /**
   * Products that represent Plans normally have the same name, e.g. Monthly or Annual, which is then used to group the products and display Monthly/Annual tabs. Add-On Product names describe the actual Add-On, such as Extra Site.
   * @example "Monthly"
   */
  name: string;
  /**
   * The unit an Add-On is priced per (Stripe unit label, or the lowercased name).
   * @example "site"
   */
  label: string;
  description: string | null;
  /**
   * Highlights a featured most popular product.
   * @example true
   */
  highlight: boolean;
  /**
   * Defines whether an Add-On is a default one. Such Add-Ons CANNOT be added or removed from a Subscription. An example Add-On is Page Crawl and Keyword Rank Update.
   * @example true
   */
  default: boolean;
  /**
   * Defines whether an Add-On is a optional one. Such Add-Ons CAN be added from a Subscription. An example Add-On is Extra Site or AI Engine (used in previous generations).
   * @example false
   */
  optional: boolean;
  /**
   * Add-On has dependencies, if unment the addon will be removed from Subscription automatically.
   * @example true
   */
  conditional: boolean;
  /**
   * The Product is a standby (power saving mode) plan.
   * @example false
   */
  standby: boolean;
  /**
   * The Add-On is a singleton, e.g. on/off feature.
   * @example false
   */
  singleton: boolean;
  /**
   * Normally used with Enterprise, requiring a demo before the user can switch to the plan. Instead of Start we display the Book a Demo button.
   * @example false
   */
  demo: boolean;
  /**
   * A plan feature. Let's users access to Chrome extension.
   * @example true
   */
  live_edior: boolean;
  /**
   * Prerendering feature availability.
   * @example true
   */
  prerendering: boolean;
  /**
   * A plan feature. Let's users the API access to the data.
   * @example true
   */
  api_access: boolean;
  /**
   * A plan feature. Allows automated recrawls of user's websites.
   * @example true
   */
  automated_recrawl: boolean;
  /**
   * A plan feature. Adds a support chat to pages.
   * @example true
   */
  priority_support: boolean;
  /**
   * White-Label feature availability.
   * @example true
   */
  white_label: boolean;
  /** @example "Weekly" */
  crawl_interval: string;
  /** @example "Daily" */
  refresh_interval: string;
  /** Maximum number of Team Members allowed by the Plan */
  membership_max: number | null;
  /** Maximum number of Sites allowed by the Plan */
  site_max: number | null;
  /** Maximum number of Pages allowed by the Plan */
  page_max: number | null;
  /** Maximum number of Keywords allowed by the Plan */
  keyword_max: number | null;
  /** Default trial days. */
  trial_days: number | null;
  /** Pages not billed per paid Site, pooled across the account. 0 when none. */
  page_max_included: number;
  /** Keywords not billed per paid Site, pooled across the account. 0 when none. */
  keyword_max_included: number;
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  updated_at?: string;
  prices?: PaymentsPrices;
  default_addons?: PaymentsPrices;
  optional_addons?: PaymentsPrices;
}

export type PaymentsProducts = PaymentsProduct[];

export type PaymentsPriceRecurring = {
  interval: string;
  interval_count: number;
  usage_type: string;
  aggregate_usage: string | null;
};

export interface PaymentsPriceTier {
  flat_amount: number | null;
  flat_amount_decimal: string | null;
  unit_amount: number | null;
  unit_amount_decimal: string | null;
  up_to: number | null;
}

export type PaymentsPriceTiers = PaymentsPriceTier[] | null;

export interface PaymentsPaymentMethod {
  type?: "card" | "us_bank_account";
  data?: PaymentsMethodsCard | PaymentsMethodsUsBankAccount;
}

export interface PaymentsSubscription {
  id: number;
  status:
    | "intent"
    | "created"
    | "incomplete"
    | "trialing"
    | "active"
    | "past_due"
    | "unpaid"
    | "canceled"
    | "incomplete_expired";
  error_code: string | null;
  error_message: string | null;
  /** Whether a subscription is set to cancel at the end of the billing cycle (autorenewal disabled). */
  cancel_at_period_end: boolean;
  /** Whether a subscription can be suspended. */
  standbyable: boolean;
  /** Whether a checkout has been completed, but the webhooks haven't activated the subscription yet. */
  awaiting_activation: boolean;
  /** Whether the team can use the app: the status is healthy (trialing, active, past_due) and the access isn't blocked. A missing subscription means no access either. */
  healthy: boolean;
  /** Why the access is blocked, null when it isn't: the trial ended without a card (trial_ended_no_card), or the payment failed (payment_failed). */
  blocked_reason: "trial_ended_no_card" | "payment_failed" | null;
  /** Invoice to pay to restore the access, present while blocked. */
  open_invoice_id: number | null;
  /** @format date-time */
  cancel_at: string | null;
  /** @format date-time */
  start_at: string | null;
  /** @format date-time */
  ended_at: string | null;
  /** @format date-time */
  trial_start_at: string | null;
  /** @format date-time */
  trial_end_at: string | null;
  /**
   * Current billing sycle start date.
   * @format date-time
   */
  period_start_at: string | null;
  /**
   * Current billing sycle end date.
   * @format date-time
   */
  period_end_at: string | null;
  /**
   * Present when payment collection is paused for a subscription and indicates the date when it will be restore.
   * @format date-time
   */
  resumes_at: string | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  payment_method: PaymentsPaymentMethod | null;
  price: PaymentsPrice;
  subscription_addons?: PaymentsSubscriptionAddons;
}

export interface PaymentsSubscriptionLink {
  id: number;
  code: string;
  /** ID of the linked Plan Price to subscribe to. */
  price_id: number;
  trial_days: number | null;
  product: PaymentsProduct;
}

export interface PaymentsSubscriptionCreateAttributes {
  price_id: number;
  ua: string;
  subscription_code?: string;
  subscription_addons_attributes?: PaymentsSubscriptionAddonAttributes[];
}

export interface PaymentsSubscriptionUpdateAttributes {
  price_id?: number;
  subscription_code?: string;
  subscription_addons_attributes?: PaymentsSubscriptionAddonAttributes[];
}

export interface PaymentsSubscriptionCancelAttributes {
  cancel_reason?:
    | "other"
    | "technical_issues"
    | "too_expensive"
    | "switching_to_another"
    | "shutting_down"
    | "too_complex"
    | "lacks_features";
  cancel_comment?: string;
}

export interface PaymentsSubscriptionAddon {
  id: number;
  price_id: number;
  quantity: number;
  disabled: boolean;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  price: PaymentsPrice;
}

export type PaymentsSubscriptionAddons = PaymentsSubscriptionAddon[];

export interface PaymentsSubscriptionAddonAttributes {
  /** Required when updating */
  id?: number;
  price_id: number;
  quantity: number;
  /** Set to true to remove the add-on */
  _destroy?: boolean;
}

export interface PaymentsSession {
  ui_mode: "hosted" | "embedded" | "custom";
  url: string | null;
  client_secret: string | null;
}

export interface PaymentsSessionAttributes {
  ui_mode: "hosted" | "embedded" | "custom";
}

export interface PaymentsInvoice {
  id?: number;
  number?: string | null;
  status?: string;
  currency?: string;
  subtotal?: number;
  total?: number;
  tax?: number | null;
  /** @format date-time */
  period_start?: string;
  /** @format date-time */
  period_end?: string;
  /** @format date-time */
  paid_at?: string | null;
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  updated_at?: string;
}

export type PaymentsInvoices = PaymentsInvoice[];

export interface PaymentsInvoiceUrl {
  /** @format uri */
  url: string;
}

/** @example {"grouped_line_items":[["NOV  7 - DEC  7, 2024",[{"name":"Page Crawl (per crawl)","quantity":88388,"nested_items":[{"name":"First 45 000","quantity":45000,"amount":0,"unit_amount":0},{"name":"Flat fee for first 45 000","quantity":0,"amount":0,"unit_amount":0},{"name":"First 45 001","quantity":43388,"amount":0,"unit_amount":0}],"amount":null,"unit_amount":null,"per_value":null},{"name":"Rankings Update (per update)","quantity":965,"nested_items":[{"name":"First 12 500","quantity":965,"amount":0,"unit_amount":0},{"name":"Flat fee for first 12 500","quantity":0,"amount":0,"unit_amount":0}],"amount":null,"unit_amount":null,"per_value":null},{"name":"Optimized Meta Title (per title)","quantity":852,"nested_items":[{"name":"First 500","quantity":500,"amount":0,"unit_amount":0},{"name":"Flat fee for first 500","quantity":0,"amount":0,"unit_amount":0},{"name":"First 501","quantity":352,"amount":0,"unit_amount":0}],"amount":null,"unit_amount":null,"per_value":null},{"name":"Optimized Meta Description (per description)","quantity":780,"nested_items":[{"name":"First 500","quantity":500,"amount":0,"unit_amount":0},{"name":"Flat fee for first 500","quantity":0,"amount":0,"unit_amount":0},{"name":"First 501","quantity":280,"amount":0,"unit_amount":0}],"amount":null,"unit_amount":null,"per_value":null},{"name":"Optimized Page Schema (per schema)","quantity":96,"nested_items":[],"amount":0,"unit_amount":0,"per_value":null}]],["DEC  7 - JAN  7, 2024",[{"name":"AlliAI Custom","quantity":1,"nested_items":[],"amount":0,"unit_amount":0,"per_value":null},{"name":"AI Engine","quantity":1,"nested_items":[],"amount":0,"unit_amount":0,"per_value":null}]]],"current_datetime":"Mon, 02 Dec 2024 11:28:08 UTC +00:00","date":1733583902,"subtotal":0,"total":0,"amount_due":0} */
export interface PaymentsInvoiceUpcoming {
  amount_due: number;
  subtotal: number;
  total: number;
  current_datetime: string;
  date: number;
  discounts: {
    name: string | null;
    currency: string | null;
    amount_off: number | null;
    /** @format float */
    percent_off: number | null;
  }[];
  grouped_line_items: (
    | string
    | {
        /** @example 54 */
        product_id: number;
        /** @example "Rankings Update (per update)" */
        name: string;
        /**
         * @format float
         * @example 0
         */
        amount: number;
        /** @example 965 */
        quantity: number;
        /**
         * @format float
         * @example 0
         */
        unit_amount: number;
        /** @example null */
        per_value: number | null;
        /** @example [{"name":"First 12 500","quantity":965,"amount":0,"unit_amount":0},{"name":"Flat fee for first 12 500","quantity":0,"amount":0,"unit_amount":0}] */
        nested_items: {
          name: string;
          /**
           * @format float
           * @example 0
           */
          amount: number;
          quantity: number;
          /**
           * @format float
           * @example 0
           */
          unit_amount: number;
        }[];
      }[]
  )[][];
}

export interface PaymentsOrder {
  id: number;
  /** @format date-time */
  created_at: string;
  state: string;
  status: string;
  service_type: string;
  /** @format float */
  amount: number;
  sites: string[];
  package: string | null;
}

export type PaymentsOrders = PaymentsOrder[];

export interface PaymentsOffer {
  key: "autopto_upsell" | "autopto_downsell";
  order: PaymentsOrder;
  /** The Stripe payment intent status: succeeded once charged, requires_action for 3D Secure; processing and canceled are settled by the webhook, re-read the team. Null for an order paid without an intent. */
  payment_status: string | null;
  /** Only with requires_action: complete 3D Secure with Stripe.js handleNextAction, then purchase again to sync ahead of the webhook: 201 with succeeded, or 403 once the webhook has already ended the offer. */
  client_secret: string | null;
}

export interface PaymentsCreateOrderAttributes {
  site_ids: Ids;
  order_items_attributes: {
    price_id: number;
  }[];
}

export interface PaymentsOrdersStats {
  links: number;
  concierge: number;
}

export interface WidgetCategory {
  id: number;
  editable: boolean;
  kind: "automation" | "customization" | "interlink";
  category_type: "other" | "page" | "site" | "asset";
  name: string;
  slug: string;
  description: string | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type WidgetCategories = WidgetCategory[];

export type WidgetCategoriesStats = Record<
  string,
  {
    id: number;
    category_name: string;
    appearances: number;
    approved_appearances: number;
  }
>;

/** Latest PageMeta of the same kind generated for the customization's page. Present only when the customization is outdated. */
export type WidgetCustomizationFreshPageMeta = {
  id: number;
  content: string | null;
  attrs: Record<string, string>;
  source: "auto" | "manual" | "regenerate";
  /** @format date-time */
  created_at: string;
};

export interface WidgetCustomization {
  id: number;
  active: boolean;
  edited: boolean;
  outdated: boolean;
  global: boolean;
  contentful: boolean;
  kind: "meta" | "content";
  action: "insert" | "update" | "upsert" | "remove";
  position: "replace" | "prepend" | "append";
  content_type: "text" | "html";
  title: string;
  path: string;
  content: string | null;
  tag: string | null;
  attrs: Record<string, string>;
  lang: string | null;
  provider: "enhancement" | "ai" | "optimization";
  source: "auto" | "manual" | "regenerate" | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  /** Latest PageMeta of the same kind generated for the customization's page. Present only when the customization is outdated. */
  fresh_page_meta?: WidgetCustomizationFreshPageMeta;
}

export type WidgetCustomizations = WidgetCustomization[];

export interface WidgetCustomizationAttributes {
  action?: "insert" | "update" | "upsert" | "remove";
  position?: "replace" | "prepend" | "append";
  content_type?: "text" | "html";
  path?: string;
  content?: string;
  tag?: string;
  attrs?: Record<string, string>;
}

export interface WidgetCustomizationStats {
  active: number;
  total: number;
  variant: "enhancement" | "ai" | "schema" | "ai_instructions";
}

export interface WidgetRecommendation {
  id: number;
  page_id: number;
  category_id: number;
  path: string | null;
  src?: string | null;
  description: string | null;
  tag: string | null;
  inner_text: string | null;
  original: string | null;
  suggestion: string | null;
  final: string | null;
  appearances: number;
  lang: string | null;
  active: boolean;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type WidgetRecommendations = WidgetRecommendation[];

export interface WidgetRecommendationAttributes {
  final?: string;
}

export interface WidgetRecommendationAction {
  id: number;
  site_id: number;
  page_id?: number | null;
  category_id?: number | null;
  variant?: "automation" | "interlink";
  ids?: Ids;
  status: string;
  kind: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type WidgetRecommendationActions = WidgetRecommendationAction[];

export interface WidgetRecommendationActionCreateAttributes {
  variant: "automation" | "interlink";
  kind: "approve" | "unapprove";
  category_id?: number;
  page_id?: number;
  ids?: Ids;
}

export interface WidgetCustomizationAction {
  id: number;
  site_id: number;
  page_id: number | null;
  user_id: number;
  variant: "ai" | "schema" | "enhancement" | "ai_instructions";
  global: boolean;
  page_kind?: string | null;
  ids: Ids;
  status: string;
  kind: string;
  source: "auto" | "manual" | null;
  /** When true, narrows the action to outdated customizations only. Omit (or null) to act on all matching customizations including outdated ones. */
  outdated: true | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type WidgetCustomizationActions = WidgetCustomizationAction[];

export interface WidgetCustomizationActionCreateAttributes {
  kind: "approve" | "unapprove";
  variant: "ai" | "schema" | "enhancement" | "ai_instructions";
  global?: boolean;
  page_id?: number;
  page_kind?: string;
  source?: "auto" | "manual";
  /** When true, narrows the action to outdated customizations only. Omit to act on all matching customizations including outdated ones. */
  outdated?: true;
  ids?: Ids;
}

export interface TenantAccount {
  id: number;
  name: string;
  address: string | null;
  support_email: string | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  logo?: Icon | null;
}

export interface TenantAccountAttributes {
  name?: string;
  address?: string | null;
  support_email?: string | null;
  logo?: Icon | Null;
}

export interface TenantHostname {
  id: number;
  /** Hostname (FQDN) to use as a white-label domain, e.g. app.example.com */
  name: string;
  /** Hostname (FQDN) to use as a DNS-target for the hostname above, e.g. grievous-perpetuity.alliaidns.com */
  target: string;
  /**
   * URI to use as a base for the white-label domain, e.g. https://app.example.com
   * @format uri
   */
  uri?: string;
  acme_status: "pending" | "updating" | "ready" | "error";
  /** Whether the DNS record is configured */
  dns_set: boolean;
  /**
   * The last time we saw the DNS record was configured
   * @format date-time
   */
  dns_set_at: string | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  certificate?: Certificate | null;
}

export type TenantHostnames = TenantHostname[];

export interface TenantHostnameAttributes {
  /** Hostname (FQDN), e.g. app.example.com */
  name: string;
}

export interface UserProfile {
  email: string;
  first_name: string;
  last_name: string;
}

export interface User {
  id: number;
  current_team_id: number | null;
  current_team_admin: boolean;
  /** @format email */
  email: string | null;
  first_name: string;
  last_name: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  features?: Record<string, any>;
  /** Whether MFA is currently enabled for this user. */
  mfa_enabled: boolean;
  /** Whether the user must set a new password before continuing (e.g. a provisioned demo account). */
  force_password_change: boolean;
  tenant_account: TenantAccount | null;
}

export interface UserAttributes {
  current_team_id?: number;
  /** @format email */
  email: string;
  first_name: string;
  last_name: string;
  /** @format password */
  password?: string;
  /** @format password */
  password_confirmation?: string;
  /** @format password */
  current_password?: string;
}

export interface UserIdentity {
  id: number;
  user_id: number;
  kind: "auth" | "analytics" | "ext";
  provider: "google_oauth2";
  /** @example ["userinfo.email","userinfo.profile"] */
  scopes: string[];
  profile?: UserProfile;
  /** @format date-time */
  expired_at: string | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type UserIdentities = UserIdentity[];

export interface UserIdentityAttributes {
  code: string;
  /**
   * If present in the URL, should be copied into the payload.
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  subscription_uuid?: string;
  /**
   * If accepting an invitation, should be copied to the payload.
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  invitation_uuid?: string;
  /** If present in the URL, should be copied into the registration POST payload. */
  utm_campaign?: string;
  /** If present in the URL, should be copied into the registration POST payload. */
  utm_content?: string;
  /** If present in the URL, should be copied into the registration POST payload. */
  utm_medium?: string;
  /** If present in the URL, should be copied into the registration POST payload. */
  utm_source?: string;
  /** If present in the URL, should be copied into the registration POST payload. */
  utm_term?: string;
  /** If present in the URL, should be copied into the registration POST payload. */
  ref?: string;
}

export interface Team {
  id: number;
  name: string;
  custom_bot_name: string | null;
  current: boolean;
  email_invoice: boolean;
  ai_title: boolean;
  ai_description: boolean;
  ai_schema: boolean;
  ai_engine_available: boolean;
  ai_title_available: boolean;
  ai_description_available: boolean;
  ai_schema_available: boolean;
  ai_meta_override: number;
  ai_schema_override: number;
  crawl_frequency: number;
  refresh_frequency: number;
  /** @example ["one-feature","another-feature"] */
  features: string[];
  platform: "alliai" | "autopto";
  stripe_id: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  logo?: Icon | null;
  subscription: PaymentsSubscription | null;
  /** @format email */
  support_email: string | null;
  /** The white-label platform name, null without a white-label account. */
  platform_name: string | null;
  external: boolean;
  /** An Autopto team on an unpaid trial without a card: features that need a card are closed. */
  autopto_card_required: boolean;
  /** An Autopto team that hasn't named its platform yet: show the onboarding step that creates the white-label account. */
  platform_setup_required: boolean;
  /** An Autopto team that hasn't answered the onboarding survey yet. */
  onboarding_survey_required: boolean;
  /** The one-time offer page to show the admin right after the first card: the upsell, then the downsell once it's declined. Null when there's none. */
  autopto_offer: "autopto_upsell" | "autopto_downsell" | null;
  /**
   * When the team watched the Autopto onboarding tour.
   * @format date-time
   */
  onboarding_tour_watched_at: string | null;
  /**
   * When the team booked the Autopto launch call.
   * @format date-time
   */
  onboarding_launch_call_at: string | null;
}

export type Teams = Team[];

export interface TeamAttributes {
  /**
   * A signed ID returned by the uploads API
   * @example "eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBaVFNIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--f91fdc34d09133db81aa9089854ccbd00111b6f2"
   */
  logo?: string;
  name?: string;
  custom_bot_name?: string;
  email_invoice?: boolean;
  ai_title?: boolean;
  ai_description?: boolean;
  ai_schema?: boolean;
  ai_meta_override?: number;
  ai_schema_override?: number;
  /** @format date-time */
  onboarding_tour_watched_at?: string | null;
  /** @format date-time */
  onboarding_launch_call_at?: string | null;
  onboarding_survey?: TeamOnboardingSurvey;
  /** The hubspotutk browser cookie for onboarding survey attribution. Not persisted. */
  hutk?: string;
  /** Onboarding survey page metadata. Not persisted. The API adds the client IP. */
  hubspot_context?: {
    page_uri?: string;
    page_name?: string;
  };
}

export interface TeamOnboardingSurvey {
  aeo_seo_services: "not_yet" | "add_on" | "core_service";
  active_clients: "1_5" | "6_20" | "21_50" | "50_plus";
  monthly_retainer: "under_1k" | "1k_3k" | "3k_10k" | "10k_plus";
  launch_timeline: "today" | "this_week" | "this_month" | "not_sure";
}

export interface TeamUsage {
  /** Usage limits, including limits solely from the Plan. */
  plan_limits: MetricsPlanLimits;
  /** Usage limits, including limits from the Plan and AddOns. */
  team_limits: MetricsTeamLimits;
  /** Free credits. */
  free_limits: MetricsFreeLimits;
  /** Already logged usage during the current billing cycle. */
  current_usage: MetricsCurrentUsage;
  /** Estimated planned usage till the end of the current billing cycle. */
  estimated_usage: MetricsEstimatedUsage;
}

export interface Invitation {
  id: number;
  admin: boolean;
  /** @format email */
  email: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  tenant_account_id: number | null;
  team_name: string;
  team_logo: Icon | null;
  site_ids: Ids;
  site_names?: Tags;
}

export type Invitations = Invitation[];

export interface InvitationAttributes {
  admin?: boolean;
  /** @format email */
  email: string;
  tenant_account_id?: number | null;
  site_ids?: Ids;
}

export interface Membership {
  id: number;
  admin: boolean;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  site_ids?: Ids;
  site_names?: Tags;
  user: User;
}

export type Memberships = Membership[];

export interface MembershipAttributes {
  admin?: boolean;
  site_ids?: Ids;
}

export interface Notification {
  id: number;
  site_id: number;
  kind:
    | "account"
    | "site"
    | "automation"
    | "interlink"
    | "keyword"
    | "keyword_import";
  priority: "low" | "normal" | "warning" | "critical";
  title: string;
  message: string;
  /** @format date-time */
  created_at: string;
  notification_subjects: [number, string][];
}

export interface UserNotification {
  id: number;
  /** @format date-time */
  read_at: string | null;
  /** @format date-time */
  created_at: string;
  notification?: Notification;
}

export type UserNotifications = UserNotification[];

export interface Certificate {
  /** @format int64 */
  id: number;
  /** @format int64 */
  domain_id: number;
  /** @format int64 */
  site_id: number | null;
  /** @format int64 */
  tenant_hostname_id: number | null;
  issuer: "custom" | "letsencrypt";
  /** @example "Let's Encrypt" */
  issuer_name: string | null;
  /** @example "*.alliai.com" */
  subject: string;
  /** @example "3747795799461898816622673427755041643920583" */
  serial: string;
  /** @example ["*.alliai.com","www.alliai.com"] */
  alt_names: string[];
  /** @format date-time */
  not_before: string;
  /** @format date-time */
  not_after: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type Certificates = Certificate[];

export interface CertificateOrder {
  /** @format int64 */
  id: number;
  /** @format int64 */
  domain_id: number;
  /** @format int64 */
  site_id: number | null;
  /** @format int64 */
  tenant_hostname_id: number | null;
  /** @format int64 */
  certificate_id: number | null;
  issuer: "letsencrypt";
  status:
    | "pending"
    | "ordered"
    | "verified"
    | "obtained"
    | "completed"
    | "failed"
    | "expired"
    | "suspended";
  /** @example "The key authorization file from the server did not match this challenge." */
  error: string | null;
  challenges: (
    | (
        | string
        | {
            wildcard: boolean | null;
            /** @example "rUzYJaFu13vTdsRpOBHCgMmrsyIpXP2mgdHEcydNi1M" */
            "http-01": string;
          }
      )[]
    | (
        | string
        | {
            wildcard: boolean | null;
            /** @example "te5a8twLOBr53yrfKBlnug5_MuQg89NrRzJS2iCvepg" */
            "dns-01": string;
          }
      )[]
  )[];
  /** @example ["*.alliai.com","www.alliai.com"] */
  identifiers: string[];
  /** @format date-time */
  expires_at: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type CertificateOrders = CertificateOrder[];

export interface Domain {
  id: number;
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
  name: string;
  acme_state?:
    | "pending"
    | "ordered"
    | "verified"
    | "obtained"
    | "completed"
    | "failed"
    | "expired"
    | "suspended";
  acme_status?: "pending" | "updating" | "ready" | "error";
  dns_state: "pending" | "initializing" | "configuring" | "ready" | "failed";
  dns_status?: "pending" | "updating" | "ready" | "error";
  verification_state?: "pending" | "ready" | "error";
  ns_state?: "pending" | "ready" | "error";
  integration_type: "full" | "partial" | "edge" | "plugin" | null;
  status: DomainStatus;
  verification_set: boolean;
  ns_set: boolean;
  /** @format date-time */
  verified_at: string | null;
  /** @format date-time */
  ns_set_at: string | null;
  apex_cname?: boolean;
  sites: DomainSites;
  user_config_error?: Error | null;
  /** Pending config not yet stored in DNS (the part provided by the user). */
  user_config_pending?: DnsConfig | null;
  /** Actual config stored in DNS (the part provided by the user). */
  user_config?: DnsConfig;
  /** Actual config stored in DNS (the part maintained by Alli AI). */
  system_config?: DnsConfig;
  /** Actual config stored in DNS. */
  config?: DnsConfig;
  certificate_provider?: "custom" | "letsencrypt" | null;
  /** Configuration steps based on selected integration type. */
  wizard_steps?:
    | DomainInitialSteps
    | DomainFullIntegrationSteps
    | DomainPartialIntegrationSteps
    | DomainEdgeIntegrationSteps
    | DomainPluginIntegrationSteps;
  /** Remaining configuration steps. */
  steps_pending?:
    | DomainInitialSteps
    | DomainFullIntegrationSteps
    | DomainPartialIntegrationSteps
    | DomainEdgeIntegrationSteps
    | DomainPluginIntegrationSteps;
  /** Finished steps. */
  steps_complete?:
    | DomainInitialSteps
    | DomainFullIntegrationSteps
    | DomainPartialIntegrationSteps
    | DomainEdgeIntegrationSteps
    | DomainPluginIntegrationSteps;
  /** Previously recorded as complete but now requires attention. */
  steps_incomplete?:
    | DomainInitialSteps
    | DomainFullIntegrationSteps
    | DomainPartialIntegrationSteps
    | DomainEdgeIntegrationSteps
    | DomainPluginIntegrationSteps;
  distinct: boolean;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type Domains = Domain[];

export interface DomainUpdateAttributes {
  integration_type?: "full" | "partial" | "edge" | "plugin";
  /** Pending config not yet stored in DNS (the part provided by the user). */
  user_config_pending?: DnsConfig;
  /**
   * Zone file.
   * @format binary
   */
  zone_file?: File;
}

export interface DomainCertificateAttributes {
  certificate_provider: "custom" | "letsencrypt";
  /** ID of an existing custom certificate. */
  certificate_id?: number;
  /**
   * Required when selecting a custom certificate, if no certificate_id present.
   * @format binary
   */
  certificate_file?: File;
  /**
   * Required when selecting a custom certificate, if no certificate_id present.
   * @format binary
   */
  certificate_key?: File;
}

export interface DelegatedDomain {
  id: number;
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
  name: string;
  integration_type: "full" | "partial" | "edge" | "plugin" | null;
  status: DomainStatus;
  verification_set: boolean;
  ns_set: boolean;
  /** @format date-time */
  verified_at: string | null;
  /** @format date-time */
  ns_set_at: string | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export interface DomainStatus {
  setup: boolean;
  /** full, partial, edge integration */
  verification?: boolean;
  /** full, partial integration */
  certificate?: boolean;
  /** full, partial integration */
  dns?: boolean;
  /** full integration */
  ns?: boolean;
  /** partial (easy) integration */
  routing?: boolean;
  /** edge integration */
  confirmation?: boolean;
  /** plugin integration */
  install?: boolean;
  /** plugin integration */
  configure?: boolean;
}

export interface DomainSite {
  id: number;
  name: string;
  prerendering_enabled: boolean;
  host_names: string[];
  dns_names: (string | null)[];
}

export type DomainSites = DomainSite[];

/** @example {"www.alliai.com":{"80":{"host":"www.alliai.com","duration":204.764,"status":301,"message":"Moved Permanently","error":"Unexpected Error Example"},"443":{"host":"www.alliai.com","duration":358.487,"status":200,"message":"OK","error":"Unexpected Error Example"}}} */
export type DomainOrigins = Record<string, any>;

/**
 * All known steps, normally when integration type is not set yet.
 * @example ["setup"]
 */
export type DomainInitialSteps = "setup"[];

/**
 * All known steps for the full integration type.
 * @example ["setup","verification","certificate","dns","ns"]
 */
export type DomainFullIntegrationSteps = (
  | "setup"
  | "verification"
  | "certificate"
  | "dns"
  | "ns"
)[];

/**
 * All known steps for the partial (easy) integration type.
 * @example ["setup","verification","certificate","dns","routing"]
 */
export type DomainPartialIntegrationSteps = (
  | "setup"
  | "verification"
  | "certificate"
  | "dns"
  | "routing"
)[];

/**
 * All known steps for the edge integration type.
 * @example ["setup","verification","confirmation"]
 */
export type DomainEdgeIntegrationSteps = (
  | "setup"
  | "verification"
  | "confirmation"
)[];

/**
 * All known steps for the plugin integration type.
 * @example ["setup","install","configure"]
 */
export type DomainPluginIntegrationSteps = (
  | "setup"
  | "install"
  | "configure"
)[];

/** @example {"alliai.com":{"ns1.alliaidns.com.":true,"ns2.alliaidns.com.":false,"ns3.alliaidns.com.":null,"ns4.alliaidns.com.":null}} */
export type NsHostsState = Record<string, Record<string, boolean | null>>;

/** @example {"alliai.com":{"cname":true,"aaaa":false,"a":null}} */
export type RoutingHostsState = Record<
  string,
  {
    cname: boolean | null;
    aaaa: boolean | null;
    a: boolean | null;
  }
>;

export interface PageImportStats {
  duplicate: number;
  invalid: number;
  created: number;
  updated: number;
}

export interface PageImport {
  id: number;
  status:
    | "pending"
    | "parsed"
    | "updated"
    | "importing"
    | "error"
    | "completed";
  stats: PageImportStats;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  input_file: Attachment;
  has_pages: boolean;
  total_count: number;
}

export interface Site {
  id: number;
  /** Default dashboard ID */
  site_dashboard_id: number | null;
  url: string;
  name: string;
  fqdn: string;
  alt_fqdn: string | null;
  domain: string;
  tld: string;
  trd: string | null;
  focus_keyword_id: number | null;
  focus_keyword_user_id: number | null;
  focus_keyword_set_at: string | null;
  focus_keyword_name: string | null;
  primary_country: string | null;
  primary_language: string | null;
  site_type: string | null;
  platform_cms:
    | "other"
    | "wordpress"
    | "shopify"
    | "wix"
    | "squarespace"
    | "webflow"
    | "hubspot"
    | "adobe_experience_manager"
    | "lovable";
  page_max_override: number | null;
  /** @default "unknown" */
  suggestions_status: "unknown" | "in_progress" | "failed" | "completed";
  crawl_frequency_override: number | null;
  crawl_frequency: number;
  crawl_interval: string;
  crawl_concurrency: number;
  crawl_status: string;
  crawl_mode: string;
  crawl_queued: boolean;
  customizations_auto_approval: boolean;
  recommendations_auto_approval: boolean;
  interlinks_auto_approval: boolean;
  schemas_auto_approval: boolean;
  ai_instructions_auto_approval: boolean;
  self_hosted: boolean;
  self_hosted_url: string | null;
  ai_meta_override: number;
  ai_schema_override: number;
  ai_title: boolean;
  ai_description: boolean;
  ai_schema: boolean;
  site_speed_status: "pending" | "approved" | "rejected" | null;
  site_speed_requested: boolean;
  prerendering: boolean;
  prerendered: boolean;
  proxied: boolean;
  proxy_token: string | null;
  cloudflare: boolean;
  apex_redirect: boolean;
  inject_widget: boolean;
  inject_markdown: "hidden" | "visible" | "shortcut" | null;
  disable_defer_automation: boolean;
  disable_lazy_automation: boolean;
  disable_preload_automation: boolean;
  widget_installed: boolean;
  prerendering_status:
    | "enabled"
    | "rejected"
    | "approved"
    | "requested"
    | "disabled";
  schema_page_types: PageTypes | null;
  delegated_domain: DelegatedDomain;
  waf_enabled: boolean;
  waf_level: "lite" | "normal" | "strict";
  waf_exclusions: (
    | "cpanel"
    | "dokuwiki"
    | "drupal"
    | "nextcloud"
    | "phpbb"
    | "phpmyadmin"
    | "woocommerce"
    | "wordpress"
    | "xenforo"
  )[];
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  crawled_at?: string | null;
  /** @format date-time */
  updated_at: string;
  favicon?: Icon | Null;
  screenshot_desktop?: Screenshot | Null;
  screenshot_mobile?: Screenshot | Null;
  page_import?: PageImport | Null;
}

export type Sites = Site[];

export interface SiteCreateAttributes {
  url: string;
  platform_cms:
    | "other"
    | "wordpress"
    | "shopify"
    | "wix"
    | "squarespace"
    | "webflow"
    | "hubspot"
    | "adobe_experience_manager"
    | "lovable";
  primary_country?: string;
  primary_language?: string;
  site_type?: string;
  page_max_override?: number;
  crawl_mode?: string;
  customizations_auto_approval?: boolean;
  recommendations_auto_approval?: boolean;
  interlinks_auto_approval?: boolean;
  schemas_auto_approval?: boolean;
  ai_instructions_auto_approval?: boolean;
  ai_schema_override?: number;
  prerendering?: boolean;
  page_imports_attributes?: PageImportsAttributes;
  waf_enabled?: boolean;
  waf_level?: "lite" | "normal" | "strict";
  waf_exclusions?: (
    | "cpanel"
    | "dokuwiki"
    | "drupal"
    | "nextcloud"
    | "phpbb"
    | "phpmyadmin"
    | "woocommerce"
    | "wordpress"
    | "xenforo"
  )[];
}

export interface SiteUpdateAttributes {
  page_max_override?: number | null;
  crawl_mode?: string;
  crawl_frequency_override?: number | null;
  crawl_concurrency?: number;
  customizations_auto_approval?: boolean;
  recommendations_auto_approval?: boolean;
  interlinks_auto_approval?: boolean;
  schemas_auto_approval?: boolean;
  ai_instructions_auto_approval?: boolean;
  self_hosted?: boolean;
  self_hosted_url?: string | null;
  ai_meta_override?: number;
  ai_schema_override?: number;
  ai_title?: boolean;
  ai_description?: boolean;
  ai_schema?: boolean;
  prerendering?: boolean;
  apex_redirect?: boolean;
  inject_widget?: boolean;
  /** @default "hidden" */
  inject_markdown?: "hidden" | "visible" | "shortcut";
  disable_defer_automation?: boolean;
  disable_lazy_automation?: boolean;
  disable_preload_automation?: boolean;
  schema_page_types?: PageTypes | null;
  page_imports_attributes?: PageImportsAttributes;
  waf_enabled?: boolean;
  waf_level?: "lite" | "normal" | "strict";
  waf_exclusions?: (
    | "cpanel"
    | "dokuwiki"
    | "drupal"
    | "nextcloud"
    | "phpbb"
    | "phpmyadmin"
    | "woocommerce"
    | "wordpress"
    | "xenforo"
  )[];
}

export interface SiteGoals {
  site_speed: string | null;
  snippet: string | null;
  keywords: string;
  recommendations: string;
  ai_customizations: string | null;
  schema: string | null;
  enhancement_customizations: string | null;
}

export interface SiteDailyGoal {
  completed: boolean;
  kind:
    | "set_focus_keyword"
    | "review_recommendations"
    | "build_brand_link"
    | "review_keywords"
    | "review_ai_customizations"
    | "build_niche_link"
    | "build_outreach_link"
    | "review_interlinks";
}

export type SiteDailyGoals = SiteDailyGoal[];

export interface SiteStats {
  id: number;
  keywords: SiteKeywordStats;
  pages: SitePagesStats;
  recommendations: SiteRecommendationsStats;
}

export interface SiteKeywordStats {
  total: number;
  top_5: number;
  top_5_percent: number;
  top_10: number;
  top_10_percent: number;
  top_25: number;
  top_25_percent: number;
  top_100: number;
  top_100_percent: number;
  life: number;
  life_percent: number;
}

export interface SitePagesStats {
  total: number;
  optimized: number;
}

export interface SiteRecommendationsStats {
  total: number;
  active: number;
}

export interface SiteWidget {
  id: number;
  site_key: string;
  self_hosted: boolean;
  /** @format uri */
  self_hosted_url: string | null;
  /** @format uri */
  cdn_url: string;
  invalid_installations: number | null;
  widget_enabled: boolean;
  widget_installed: boolean;
  /** @format uri */
  widget_data_uri?: string;
}

export interface SiteDeveloperInstructions {
  /** @format email */
  email: string;
  message: string;
}

export interface SiteDashboard {
  id: number;
  name: string;
  properties: SiteDashboardProperties | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type SiteDashboards = SiteDashboard[];

export interface SiteDashboardAttributes {
  name: string;
  properties?: SiteDashboardProperties;
}

export interface SiteDashboardProperties {
  config?: Record<string, any>;
  /**
   * Array of widget configurations.
   * @maxItems 50
   */
  widgets: ((
    | {
        integration: "google_analytics";
        method: "property_report" | "property_realtime_report";
      }
    | {
        integration: "google_search_console";
        method: "search_analytics";
      }
  ) & {
    /**
     * A unique widget ID used by the client to match the data.
     * @minLength 1
     * @maxLength 255
     * @pattern ^[a-zA-Z0-9_\-\.]*$
     */
    id: string;
    /** The integration service to use (Google Analytics or Search Console at the moment). */
    integration: "google_analytics" | "google_search_console";
    /** The API method to call. */
    method: "property_report" | "property_realtime_report" | "search_analytics";
    /** Varies based on the integration and method. */
    query:
      | {
          /**
           * Date ranges for the report.
           * @maxItems 5
           * @minItems 1
           */
          ranges?: string[][];
          /**
           * Dimensions to group the data by.
           * @maxItems 20
           * @minItems 1
           */
          dimensions?: string[];
          /**
           * Metrics to calculate.
           * @maxItems 20
           * @minItems 1
           */
          metrics?: string[];
          /**
           * Whether to return only organic search traffic
           * @default false
           */
          organic?: boolean;
          /**
           * Maximum number of rows to return
           * @min 1
           * @max 1000
           */
          limit?: number;
          [key: string]: any;
        }
      | {
          /**
           * Dimensions to group the realtime data by.
           * @maxItems 20
           * @minItems 1
           */
          dimensions?: string[];
          /**
           * Metrics to calculate.
           * @maxItems 20
           * @minItems 1
           */
          metrics?: string[];
          /**
           * Maximum number of rows to return.
           * @min 1
           * @max 100
           */
          limit?: number;
          [key: string]: any;
        }
      | {
          /**
           * Start date for the search analytics report
           * @format date
           */
          start_date?: string;
          /**
           * End date for the search analytics report.
           * @format date
           */
          end_date?: string;
          /**
           * Dimensions to group the search data by.
           * @maxItems 20
           * @minItems 1
           */
          dimensions?: string[];
          /**
           * Maximum number of rows to return
           * @min 1
           * @max 1000
           */
          row_limit?: number;
          [key: string]: any;
        }
      | Record<string, any>;
    /** Any client-specific settings, such as name, size, position, etc. */
    metadata?: Record<string, any>;
  })[];
}

export interface SiteDashboardView {
  id: number;
  data: SiteDashboardData;
}

export interface SiteDashboardData {
  widgets: (SiteDashboardWidgetData | SiteDashboardWidgetError)[];
}

export interface SiteDashboardWidgetData {
  /** A unique widget ID used by the client to match the data */
  id: string;
  data: Record<string, any>;
}

export interface SiteDashboardWidgetError {
  /** A unique widget ID used by the client to match the data */
  id: string;
  data: {
    error:
      | "integration_not_found"
      | "integration_incomplete"
      | "integration_unauthorized"
      | "query_invalid"
      | "query_error";
  };
}

export interface SiteIntegration {
  id: number;
  site_id: number;
  user_identity_id: number;
  kind: "google_analytics" | "google_search_console";
  properties: (
    | SiteIntegrationGoogleAnalytics
    | SiteIntegrationGoogleSearchConsole
  )[];
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type SiteIntegrations = SiteIntegration[];

export interface SiteIntegrationAttributes {
  user_identity_id?: number;
  kind?: "google_analytics" | "google_search_console";
  properties?: (
    | SiteIntegrationGoogleAnalytics
    | SiteIntegrationGoogleSearchConsole
  )[];
}

export type SiteIntegrationConfiguration = {
  id: string;
  name: string;
  properties: (
    | SiteIntegrationGoogleAnalytics
    | SiteIntegrationGoogleSearchConsole
  )[];
}[];

export interface SiteIntegrationGoogleAnalytics {
  /** @example "properties/123" */
  id: string;
  /** @example "Alli AI - GA4" */
  name: string;
  /** @example "accounts/123" */
  url: string;
}

export interface SiteIntegrationGoogleSearchConsole {
  /** @example "https://www.alliai.com/" */
  id: string;
  /** @example "https://www.alliai.com/" */
  name: string;
  /** @example "https://www.alliai.com/" */
  url: string;
  /** @example "siteFullUser" */
  permission_level: string;
}

export interface SiteVisitor {
  total: number;
  bot: boolean;
  kind: "unknown" | "se" | "llm";
  family: string;
  name: string;
  platform: string;
}

export type SiteVisitorBreakdown = SiteVisitor[];

export interface SiteVisitTimeSerie {
  /**
   * Epoch in seconds
   * @format int32
   */
  period: number;
  total: number;
  bot: boolean;
  kind: "unknown" | "se" | "llm";
  family: string;
  name: string;
  platform: string;
}

export type SiteVisitTimeSeries = SiteVisitTimeSerie[];

export interface SiteWafTimeSerie {
  /**
   * Epoch in seconds
   * @format int32
   */
  period: number;
  /**
   * Number of events per time window
   * @format int32
   */
  total: number;
  /**
   * OWASP CRS Rule ID
   * @format int32
   */
  rule_id: number;
  /**
   * Custom WAF Directive ID
   * @format int64
   */
  directive_id: number;
  /** Bot or not */
  bot: boolean;
  /** Action taken by the WAF */
  action: "log" | "allow" | "deny" | "detect";
}

export type SiteWafTimeSeries = SiteWafTimeSerie[];

export interface SiteWafBreakdownItem {
  /**
   * Number of events in the range
   * @format int32
   */
  total: number;
  /**
   * OWASP CRS Rule ID
   * @format int32
   */
  rule_id: number;
  /**
   * Custom WAF Directive ID
   * @format int64
   */
  directive_id: number;
  /** Bot or not */
  bot: boolean;
  /** Action taken by the WAF */
  action: "log" | "allow" | "deny" | "detect";
}

export type SiteWafBreakdown = SiteWafBreakdownItem[];

export interface SiteErrorTimeSerie {
  /**
   * Epoch in seconds
   * @format int32
   */
  period: number;
  /**
   * Number of errors per time window
   * @format int32
   */
  total: number;
  /**
   * HTTP status code
   * @format int32
   */
  status: number;
  /** Bot or not */
  bot: boolean;
  /** Error kind */
  kind: "connection" | "backend";
  /** Error category */
  category:
    | "origin_down"
    | "origin_reset"
    | "origin_timeout"
    | "dns_failure"
    | "tls_error"
    | "origin_closed"
    | "network_error"
    | "protocol_error"
    | "backend";
}

export type SiteErrorTimeSeries = SiteErrorTimeSerie[];

export interface SiteErrorBreakdownItem {
  /**
   * Number of errors in the range
   * @format int32
   */
  total: number;
  /**
   * HTTP status code
   * @format int32
   */
  status: number;
  /** Bot or not */
  bot: boolean;
  /** Error kind */
  kind: "connection" | "backend";
  /** Error category */
  category:
    | "origin_down"
    | "origin_reset"
    | "origin_timeout"
    | "dns_failure"
    | "tls_error"
    | "origin_closed"
    | "network_error"
    | "protocol_error"
    | "backend";
}

export type SiteErrorBreakdown = SiteErrorBreakdownItem[];

export interface ProxyRequest {
  /** @format uuid */
  id: string;
  level: "debug" | "info" | "warn" | "error";
  region?: string | null;
  node: string;
  kind?: "unknown" | "page" | "stylesheet" | "script" | "image" | "font" | null;
  bot?: boolean | null;
  benign?: boolean | null;
  client_ip?: string | null;
  host?: string | null;
  port?: number | null;
  status?: number | null;
  verb?:
    | "get"
    | "post"
    | "put"
    | "delete"
    | "patch"
    | "head"
    | "options"
    | "connect"
    | "trace"
    | null;
  proxy_mode?: "bypass" | "normal" | "test" | "edge" | null;
  caching_mode?: "soft" | "hard" | "white-label" | null;
  cache?: "found" | "hit" | "miss" | "dynamic" | null;
  duration?: number | null;
  uri?: string | null;
  ua?: string | null;
  err?: string | null;
  trace?: string | null;
  message: string;
  waf_action?: "log" | "allow" | "deny" | "detect" | null;
  waf_level?: number | null;
  waf_phase?: number | null;
  waf_rule?: number | null;
  waf_directive?: number | null;
  /** All contributing CRS rules with their match details */
  waf_match?:
    | {
        /** OWASP CRS Rule ID */
        rid?: number;
        matches?: {
          Variable?: string;
          Key?: string;
          Value?: string;
        }[];
      }[]
    | null;
  guard_action?: "allow" | "deny" | "suspend" | "recover" | null;
  /** Guard event counter per action type */
  guard_serial?: number | null;
  /** @format date-time */
  created_at: string;
}

export type ProxyRequests = ProxyRequest[];

export interface SiteWafDirective {
  /** @format int64 */
  id: number;
  /** @format int64 */
  site_id: number;
  rules: number[];
  groups: number[];
  action: "log" | "allow" | "deny";
  /** @format int32 */
  priority: number;
  conditions: {
    path?: {
      /**
       * @minItems 1
       * @uniqueItems true
       */
      equals?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      prefix?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      glob?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      regex?: string[];
    };
    method?: {
      /**
       * @minItems 1
       * @uniqueItems true
       */
      in: ("GET" | "POST" | "PUT" | "PATCH" | "DELETE" | "HEAD" | "OPTIONS")[];
    };
    scheme?: {
      /**
       * @minItems 1
       * @uniqueItems true
       */
      in: ("http" | "https")[];
    };
    host?: {
      /**
       * @minItems 1
       * @uniqueItems true
       */
      equals?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      suffix?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      regex?: string[];
    };
    content_type?: {
      /**
       * @minItems 1
       * @uniqueItems true
       */
      equals?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      prefix?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      regex?: string[];
    };
    ip?: {
      /**
       * @minItems 1
       * @uniqueItems true
       */
      cidr: string[];
    };
    query?: {
      /**
       * @maxItems 5
       * @minItems 1
       */
      match: {
        name?: string | string[];
        /** @minLength 1 */
        name_regex?: string;
        exists?: boolean;
        equals?: string | string[];
        contains?: string | string[];
        /** @minLength 1 */
        regex?: string;
      }[];
    };
    headers?: {
      /**
       * @maxItems 5
       * @minItems 1
       */
      match: {
        name: string | string[];
        exists?: boolean;
        equals?: string | string[];
        contains?: string | string[];
        /** @minLength 1 */
        regex?: string;
      }[];
    };
    cookies?: {
      /**
       * @maxItems 5
       * @minItems 1
       */
      match: {
        name: string | string[];
        exists?: boolean;
        equals?: string | string[];
        contains?: string | string[];
        /** @minLength 1 */
        regex?: string;
      }[];
    };
  };
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type SiteWafDirectives = SiteWafDirective[];

export interface SiteWafDirectiveAttributes {
  rules?: number[];
  groups?: number[];
  action?: "log" | "allow" | "deny";
  /** @format int32 */
  priority?: number;
  conditions?: {
    path?: {
      /**
       * @minItems 1
       * @uniqueItems true
       */
      equals?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      prefix?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      glob?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      regex?: string[];
    };
    method?: {
      /**
       * @minItems 1
       * @uniqueItems true
       */
      in: ("GET" | "POST" | "PUT" | "PATCH" | "DELETE" | "HEAD" | "OPTIONS")[];
    };
    scheme?: {
      /**
       * @minItems 1
       * @uniqueItems true
       */
      in: ("http" | "https")[];
    };
    host?: {
      /**
       * @minItems 1
       * @uniqueItems true
       */
      equals?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      suffix?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      regex?: string[];
    };
    content_type?: {
      /**
       * @minItems 1
       * @uniqueItems true
       */
      equals?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      prefix?: string[];
      /**
       * @minItems 1
       * @uniqueItems true
       */
      regex?: string[];
    };
    ip?: {
      /**
       * @minItems 1
       * @uniqueItems true
       */
      cidr: string[];
    };
    query?: {
      /**
       * @maxItems 5
       * @minItems 1
       */
      match: {
        name?: string | string[];
        /** @minLength 1 */
        name_regex?: string;
        exists?: boolean;
        equals?: string | string[];
        contains?: string | string[];
        /** @minLength 1 */
        regex?: string;
      }[];
    };
    headers?: {
      /**
       * @maxItems 5
       * @minItems 1
       */
      match: {
        name: string | string[];
        exists?: boolean;
        equals?: string | string[];
        contains?: string | string[];
        /** @minLength 1 */
        regex?: string;
      }[];
    };
    cookies?: {
      /**
       * @maxItems 5
       * @minItems 1
       */
      match: {
        name: string | string[];
        exists?: boolean;
        equals?: string | string[];
        contains?: string | string[];
        /** @minLength 1 */
        regex?: string;
      }[];
    };
  };
}

export interface SiteCustomizationAction {
  /** @format int64 */
  id: number;
  /** @format int64 */
  site_id: number;
  status: "pending" | "in_progress" | "completed" | "failed" | "aborted";
  mode: "regenerate" | "manual" | "auto";
  variants: ("title" | "description" | "schema" | "summary")[];
  conditions: {
    /** @maxLength 2048 */
    path_eq?: string;
    /** @maxLength 2048 */
    path_not_eq?: string;
    /** @maxLength 2048 */
    path_start?: string;
    /** @maxLength 2048 */
    path_not_start?: string;
    /** @maxLength 2048 */
    path_end?: string;
    /** @maxLength 2048 */
    path_not_end?: string;
    /** @maxLength 2048 */
    path_cont?: string;
    /** @maxLength 2048 */
    path_not_cont?: string;
    /** @maxLength 2048 */
    query_eq?: string;
    /** @maxLength 2048 */
    query_not_eq?: string;
    /** @maxLength 2048 */
    query_start?: string;
    /** @maxLength 2048 */
    query_not_start?: string;
    /** @maxLength 2048 */
    query_end?: string;
    /** @maxLength 2048 */
    query_not_end?: string;
    /** @maxLength 2048 */
    query_cont?: string;
    /** @maxLength 2048 */
    query_not_cont?: string;
    /**
     * @maxItems 500
     * @uniqueItems true
     */
    id_in?: number[];
    /**
     * @maxItems 500
     * @uniqueItems true
     */
    id_not_in?: number[];
    /**
     * @maxItems 11
     * @uniqueItems true
     */
    status_in?: (
      | "pending"
      | "in_progress"
      | "failed"
      | "completed"
      | "ignored"
      | "incompatible"
      | "unreachable"
      | "noindex"
      | "duplicate"
      | "offsite"
      | "excluded"
    )[];
    /**
     * @maxItems 11
     * @uniqueItems true
     */
    status_not_in?: (
      | "pending"
      | "in_progress"
      | "failed"
      | "completed"
      | "ignored"
      | "incompatible"
      | "unreachable"
      | "noindex"
      | "duplicate"
      | "offsite"
      | "excluded"
    )[];
    /**
     * @maxItems 11
     * @uniqueItems true
     */
    kind_in?: (
      | "unknown"
      | "unidentified"
      | "article"
      | "event"
      | "faq"
      | "organization"
      | "person"
      | "product"
      | "video"
      | "job"
      | "contact"
    )[];
    /**
     * @maxItems 11
     * @uniqueItems true
     */
    kind_not_in?: (
      | "unknown"
      | "unidentified"
      | "article"
      | "event"
      | "faq"
      | "organization"
      | "person"
      | "product"
      | "video"
      | "job"
      | "contact"
    )[];
    /**
     * @maxItems 4
     * @uniqueItems true
     */
    with_customization_kind?: (
      | "title"
      | "description"
      | "schema"
      | "ai_instructions"
    )[];
    /**
     * @maxItems 4
     * @uniqueItems true
     */
    without_customization_kind?: (
      | "title"
      | "description"
      | "schema"
      | "ai_instructions"
    )[];
    /**
     * @maxItems 4
     * @uniqueItems true
     */
    without_any_customization_kind?: (
      | "title"
      | "description"
      | "schema"
      | "ai_instructions"
    )[];
    m?: "and" | "or";
    g?: Record<
      string,
      {
        /** @maxLength 2048 */
        path_eq?: string;
        /** @maxLength 2048 */
        path_not_eq?: string;
        /** @maxLength 2048 */
        path_start?: string;
        /** @maxLength 2048 */
        path_not_start?: string;
        /** @maxLength 2048 */
        path_end?: string;
        /** @maxLength 2048 */
        path_not_end?: string;
        /** @maxLength 2048 */
        path_cont?: string;
        /** @maxLength 2048 */
        path_not_cont?: string;
        /** @maxLength 2048 */
        query_eq?: string;
        /** @maxLength 2048 */
        query_not_eq?: string;
        /** @maxLength 2048 */
        query_start?: string;
        /** @maxLength 2048 */
        query_not_start?: string;
        /** @maxLength 2048 */
        query_end?: string;
        /** @maxLength 2048 */
        query_not_end?: string;
        /** @maxLength 2048 */
        query_cont?: string;
        /** @maxLength 2048 */
        query_not_cont?: string;
        m?: "and" | "or";
        g?: Record<
          string,
          {
            /** @maxLength 2048 */
            path_eq?: string;
            /** @maxLength 2048 */
            path_not_eq?: string;
            /** @maxLength 2048 */
            path_start?: string;
            /** @maxLength 2048 */
            path_not_start?: string;
            /** @maxLength 2048 */
            path_end?: string;
            /** @maxLength 2048 */
            path_not_end?: string;
            /** @maxLength 2048 */
            path_cont?: string;
            /** @maxLength 2048 */
            path_not_cont?: string;
            /** @maxLength 2048 */
            query_eq?: string;
            /** @maxLength 2048 */
            query_not_eq?: string;
            /** @maxLength 2048 */
            query_start?: string;
            /** @maxLength 2048 */
            query_not_start?: string;
            /** @maxLength 2048 */
            query_end?: string;
            /** @maxLength 2048 */
            query_not_end?: string;
            /** @maxLength 2048 */
            query_cont?: string;
            /** @maxLength 2048 */
            query_not_cont?: string;
            m?: "and" | "or";
          }
        >;
      }
    >;
  };
  /** @format int32 */
  pages_count?: number;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type SiteCustomizationActions = SiteCustomizationAction[];

export interface SiteCustomizationActionAttributes {
  mode?: "regenerate" | "manual" | "auto";
  variants: ("title" | "description" | "schema" | "summary")[];
  conditions: {
    /** @maxLength 2048 */
    path_eq?: string;
    /** @maxLength 2048 */
    path_not_eq?: string;
    /** @maxLength 2048 */
    path_start?: string;
    /** @maxLength 2048 */
    path_not_start?: string;
    /** @maxLength 2048 */
    path_end?: string;
    /** @maxLength 2048 */
    path_not_end?: string;
    /** @maxLength 2048 */
    path_cont?: string;
    /** @maxLength 2048 */
    path_not_cont?: string;
    /** @maxLength 2048 */
    query_eq?: string;
    /** @maxLength 2048 */
    query_not_eq?: string;
    /** @maxLength 2048 */
    query_start?: string;
    /** @maxLength 2048 */
    query_not_start?: string;
    /** @maxLength 2048 */
    query_end?: string;
    /** @maxLength 2048 */
    query_not_end?: string;
    /** @maxLength 2048 */
    query_cont?: string;
    /** @maxLength 2048 */
    query_not_cont?: string;
    /**
     * @maxItems 500
     * @uniqueItems true
     */
    id_in?: number[];
    /**
     * @maxItems 500
     * @uniqueItems true
     */
    id_not_in?: number[];
    /**
     * @maxItems 11
     * @uniqueItems true
     */
    status_in?: (
      | "pending"
      | "in_progress"
      | "failed"
      | "completed"
      | "ignored"
      | "incompatible"
      | "unreachable"
      | "noindex"
      | "duplicate"
      | "offsite"
      | "excluded"
    )[];
    /**
     * @maxItems 11
     * @uniqueItems true
     */
    status_not_in?: (
      | "pending"
      | "in_progress"
      | "failed"
      | "completed"
      | "ignored"
      | "incompatible"
      | "unreachable"
      | "noindex"
      | "duplicate"
      | "offsite"
      | "excluded"
    )[];
    /**
     * @maxItems 11
     * @uniqueItems true
     */
    kind_in?: (
      | "unknown"
      | "unidentified"
      | "article"
      | "event"
      | "faq"
      | "organization"
      | "person"
      | "product"
      | "video"
      | "job"
      | "contact"
    )[];
    /**
     * @maxItems 11
     * @uniqueItems true
     */
    kind_not_in?: (
      | "unknown"
      | "unidentified"
      | "article"
      | "event"
      | "faq"
      | "organization"
      | "person"
      | "product"
      | "video"
      | "job"
      | "contact"
    )[];
    /**
     * @maxItems 4
     * @uniqueItems true
     */
    with_customization_kind?: (
      | "title"
      | "description"
      | "schema"
      | "ai_instructions"
    )[];
    /**
     * @maxItems 4
     * @uniqueItems true
     */
    without_customization_kind?: (
      | "title"
      | "description"
      | "schema"
      | "ai_instructions"
    )[];
    /**
     * @maxItems 4
     * @uniqueItems true
     */
    without_any_customization_kind?: (
      | "title"
      | "description"
      | "schema"
      | "ai_instructions"
    )[];
    m?: "and" | "or";
    g?: Record<
      string,
      {
        /** @maxLength 2048 */
        path_eq?: string;
        /** @maxLength 2048 */
        path_not_eq?: string;
        /** @maxLength 2048 */
        path_start?: string;
        /** @maxLength 2048 */
        path_not_start?: string;
        /** @maxLength 2048 */
        path_end?: string;
        /** @maxLength 2048 */
        path_not_end?: string;
        /** @maxLength 2048 */
        path_cont?: string;
        /** @maxLength 2048 */
        path_not_cont?: string;
        /** @maxLength 2048 */
        query_eq?: string;
        /** @maxLength 2048 */
        query_not_eq?: string;
        /** @maxLength 2048 */
        query_start?: string;
        /** @maxLength 2048 */
        query_not_start?: string;
        /** @maxLength 2048 */
        query_end?: string;
        /** @maxLength 2048 */
        query_not_end?: string;
        /** @maxLength 2048 */
        query_cont?: string;
        /** @maxLength 2048 */
        query_not_cont?: string;
        m?: "and" | "or";
        g?: Record<
          string,
          {
            /** @maxLength 2048 */
            path_eq?: string;
            /** @maxLength 2048 */
            path_not_eq?: string;
            /** @maxLength 2048 */
            path_start?: string;
            /** @maxLength 2048 */
            path_not_start?: string;
            /** @maxLength 2048 */
            path_end?: string;
            /** @maxLength 2048 */
            path_not_end?: string;
            /** @maxLength 2048 */
            path_cont?: string;
            /** @maxLength 2048 */
            path_not_cont?: string;
            /** @maxLength 2048 */
            query_eq?: string;
            /** @maxLength 2048 */
            query_not_eq?: string;
            /** @maxLength 2048 */
            query_start?: string;
            /** @maxLength 2048 */
            query_not_start?: string;
            /** @maxLength 2048 */
            query_end?: string;
            /** @maxLength 2048 */
            query_not_end?: string;
            /** @maxLength 2048 */
            query_cont?: string;
            /** @maxLength 2048 */
            query_not_cont?: string;
            m?: "and" | "or";
          }
        >;
      }
    >;
  };
}

export interface SiteVisibilityReport {
  platform: "desktop" | "mobile";
  pages_analyzed: number;
  /** Map of segment name to count. Missing keys mean zero. */
  segment_counts: Record<string, number>;
  /** @format float */
  avg_text_ratio: number;
  /**
   * Median (p50)
   * @format float
   */
  mdn_text_ratio: number;
  /**
   * Bottom 10% (p10)
   * @format float
   */
  btm_text_ratio: number;
  /** @format float */
  min_text_ratio: number;
  /** @format float */
  max_text_ratio: number;
  /** @format float */
  avg_content_overlap: number;
  /**
   * Median (p50)
   * @format float
   */
  mdn_content_overlap: number;
  /**
   * Bottom 10% (p10)
   * @format float
   */
  btm_content_overlap: number;
  /** @format float */
  min_content_overlap: number;
  /** @format float */
  max_content_overlap: number;
  /** @format date-time */
  updated_at: string;
}

export type SiteVisibilityReports = SiteVisibilityReport[];

export interface SitePerformanceReport {
  platform: "desktop" | "mobile";
  pages_analyzed: number;
  avg_absolute_ttfb: number;
  /** Median (p50) */
  mdn_absolute_ttfb: number;
  /** Bottom 10% (p10) */
  btm_absolute_ttfb: number;
  min_absolute_ttfb: number;
  max_absolute_ttfb: number;
  avg_relative_ttfb: number;
  /** Median (p50) */
  mdn_relative_ttfb: number;
  /** Bottom 10% (p10) */
  btm_relative_ttfb: number;
  min_relative_ttfb: number;
  max_relative_ttfb: number;
  avg_page_load: number;
  /** Median (p50) */
  mdn_page_load: number;
  /** Bottom 10% (p10) */
  btm_page_load: number;
  min_page_load: number;
  max_page_load: number;
  avg_content_load: number;
  /** Median (p50) */
  mdn_content_load: number;
  /** Bottom 10% (p10) */
  btm_content_load: number;
  min_content_load: number;
  max_content_load: number;
  /** @format date-time */
  updated_at: string;
}

export type SitePerformanceReports = SitePerformanceReport[];

export interface CrsRule {
  id: number;
  group: number;
  paranoia: number;
  phase: number;
  severity: string;
  version: string | null;
  message: string | null;
  tags: string[];
}

export type CrsRules = CrsRule[];

export interface Page {
  id: number;
  depth: number;
  status:
    | "pending"
    | "in_progress"
    | "failed"
    | "completed"
    | "ignored"
    | "incompatible"
    | "unreachable"
    | "noindex"
    | "duplicate"
    | "offsite"
    | "excluded";
  lang: string | null;
  path_and_query: string;
  /** @format uri */
  url: string;
  custom: boolean;
  widget_installed: boolean;
  crawler_error: string | null;
  customizations?: ("title" | "description" | "schema" | "ai_instructions")[];
  visibility_report: PageVisibilityReport | null;
  performance_reports: PagePerformanceReport[];
  /** @format date-time */
  crawled_at: string | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type Pages = Page[];

export interface PagePerformanceReport {
  platform: "desktop" | "mobile";
  /** TTFB in ms */
  absolute_ttfb: number;
  /** TTFB relative to navigation start, in ms */
  relative_ttfb: number;
  /** Full page load duration in ms */
  page_load: number;
  /** DOMContentLoaded duration in ms */
  content_load: number;
  /** Bucketed health score derived from TTFB + page_load thresholds */
  score: "good" | "ok" | "poor";
  /** @format date-time */
  updated_at: string;
}

export interface PageCreateAttributes {
  /** @format uri */
  url: string;
}

export interface PageBulkIgnoreAttributes {
  ids?: Ids;
  statuses?: "pending" | "failed" | "completed" | "ignored" | "noindex";
}

export interface PageBulkRecrawlAttributes {
  ids?: Ids;
  statuses?: "failed" | "completed";
}

export interface PageCustomization {
  id: number;
  path_and_query: string;
  total: number;
  approved: number;
}

export type PageCustomizations = PageCustomization[];

export interface PageAutomation {
  id: number;
  path_and_query: string;
  total: number;
  approved: number;
}

export type PageAutomations = PageAutomation[];

export interface PageStatusStats {
  /** @default 0 */
  pending: number;
  /** @default 0 */
  in_progress: number;
  /** @default 0 */
  failed: number;
  /** @default 0 */
  completed: number;
  /** @default 0 */
  ignored: number;
  /** @default 0 */
  incompatible: number;
  /** @default 0 */
  unreachable: number;
  /** @default 0 */
  noindex: number;
  /** @default 0 */
  duplicate: number;
  /** @default 0 */
  offsite: number;
  /** @default 0 */
  excluded: number;
}

export interface PageTypeStats {
  /** @default 0 */
  unknown: number;
  /** @default 0 */
  unidentified: number;
  /** @default 0 */
  article: number;
  /** @default 0 */
  event: number;
  /** @default 0 */
  faq: number;
  /** @default 0 */
  organization: number;
  /** @default 0 */
  person: number;
  /** @default 0 */
  product: number;
  /** @default 0 */
  video: number;
  /** @default 0 */
  job: number;
  /** @default 0 */
  contact: number;
}

export interface PageImportAttributes {
  /**
   * A signed ID returned by the uploads API
   * @example "eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBaVFNIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--f91fdc34d09133db81aa9089854ccbd00111b6f2"
   */
  input_file: string;
}

export type PageImportsAttributes = PageImportAttributes[];

export interface PageVisibilityReport {
  platform: "desktop" | "mobile";
  segment: "fully_accessible" | "partially_accessible" | "js_dependent";
  /** @format float */
  text_ratio: number;
  /** @format float */
  content_overlap: number;
  raw_text_chars: number;
  rendered_text_chars: number;
  raw_links: number;
  rendered_links: number;
  raw_internal_links: number;
  rendered_internal_links: number;
  raw_headings: number;
  rendered_headings: number;
  raw_paragraphs: number;
  rendered_paragraphs: number;
  raw_has_main: boolean;
  raw_title_chars: number;
  raw_meta_desc_chars: number;
  /** @format date-time */
  updated_at: string;
}

export interface Keyword {
  id: number;
  ranking_page_id: number | null;
  keyword_import_id: number | null;
  location_id: number | null;
  location_name?: string | null;
  name: string;
  language: string;
  country: string;
  /** @format uri */
  ranking_url: string | null;
  ranking_url_lock: boolean;
  pos_confirmed: boolean;
  traffic_increase: number | null;
  current_traffic: number | null;
  proj_traffic: number | null;
  proj_top_traffic: number | null;
  now_pos: number | null;
  start_pos: number | null;
  day_change: number | null;
  week_change: number | null;
  month_change: number | null;
  life_change: number | null;
  /** @format float */
  alli_score: number;
  /** @format float */
  alli_rating: number | null;
  search_vol: number | null;
  /** @format float */
  cpc: number | null;
  /** @format float */
  cmp: number | null;
  refresh_frequency_override: 3600 | 86400 | 604800 | 2629746 | 31556952 | null;
  refresh_frequency: number;
  refresh_interval: string;
  /** @format date-time */
  rank_checked_at: string | null;
  /** @format date-time */
  rank_requested_at: string | null;
  /** @format date-time */
  info_checked_at: string | null;
  /** @format date-time */
  info_requested_at: string | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type Keywords = Keyword[];

export interface KeywordAttributes {
  name: string;
  language: string;
  country: string;
  location_id?: number;
  /** @format uri */
  ranking_url?: string;
  ranking_url_lock?: boolean;
  refresh_frequency_override?: 3600 | 86400 | 604800 | 2629746 | 31556952;
}

export interface KeywordBulkAttributes {
  language?: string;
  country?: string;
  location_id?: number;
  refresh_frequency_override?: 3600 | 86400 | 604800 | 2629746 | 31556952;
}

export interface KeywordBulkDeleteAttributes {
  ids: Ids;
}

export interface KeywordBulkUpdateAttributes {
  ids: Ids;
  attributes: KeywordBulkAttributes;
}

export interface KeywordRankingMetric {
  labels: string[];
  values: number[];
}

export interface KeywordRanking {
  start: number | null;
  now: number | null;
  day: number | null;
  week: number | null;
  month: number | null;
}

export interface KeywordHistoricalRanking {
  week: KeywordRankingMetric;
  month: KeywordRankingMetric;
  alltime: KeywordRankingMetric;
}

export interface KeywordSuggestion {
  id: number;
  name: string;
  /** @format uri */
  ranking_url: string | null;
  /** @format float */
  alli_score: number;
  /** @format float */
  alli_rating: number | null;
  pos: number | null;
  msv: number | null;
  /** @format float */
  cpc: number | null;
  /** @format float */
  cmp: number | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type KeywordSuggestions = KeywordSuggestion[];

export interface KeywordImport {
  id: number;
  site_id: number;
  user_id: number;
  status: "pending" | "failed" | "complete";
  keyword_attributes: KeywordBulkAttributes;
  /** @example [["test keyword 1","complete",[]],["test keyword 2","failed",["keyword 'test keyword 2' already exists"]],["t e s t k e y w o r d 3","failed",["keyword is too long (maximum is 80 characters)","keyword too long, please keep the phrase under 10 words"]]] */
  mapped_data: (string | string[])[][];
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type KeywordImports = KeywordImport[];

export interface KeywordImportAttributes {
  /** @example ["Keyword 1","Keyword 2"] */
  names: string[];
  keyword_attributes: KeywordBulkAttributes;
}

export interface KeywordMonthlySearch {
  year: number;
  month: number;
  volume: number;
}

export type KeywordMonthlySearches = KeywordMonthlySearch[];

export interface Export {
  id: number;
  status: "created" | "processing" | "completed" | "failed" | "canceled";
  url: string | null;
  type:
    | "BuiltLinkExport"
    | "ClientReport"
    | "KeywordExport"
    | "SiteSalesReport"
    | "WorkDoneReport"
    | "Widget::RecommendationExport";
  /** @format date */
  starts_on: string | null;
  /** @format date */
  ends_on: string | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type Exports = Export[];

export interface ClientReportSchedule {
  id: number;
  frequency: "monthly" | "weekly";
  /** Day of the month (1–28), or of the week (1 Monday – 7 Sunday) */
  day: number;
  enabled: boolean;
  report_recipient_list_id: number | null;
  /** @format date */
  next_run_on: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export interface ClientReportScheduleAttributes {
  frequency?: "monthly" | "weekly";
  /** Day of the month (1–28), or of the week (1 Monday – 7 Sunday) */
  day?: number;
  enabled?: boolean;
  /** The team's recipient list each report is also emailed to */
  report_recipient_list_id?: number | null;
}

export interface ReportRecipientList {
  id: number;
  name: string;
  recipients: string[];
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export type ReportRecipientLists = ReportRecipientList[];

export interface ReportRecipientListAttributes {
  name?: string;
  /**
   * Email addresses, each either name@example.com or "Name" <name@example.com>
   * @maxItems 50
   */
  recipients?: string[];
}

export interface ClientReportRecipient {
  id: number;
  membership_id: number;
  /** @format date-time */
  created_at: string;
}

export type ClientReportRecipients = ClientReportRecipient[];

export interface Task {
  id: number;
  status: "TODO" | "DOING" | "DONE" | "CANCELLED";
  type: "BrandLink" | "NicheLink" | "OutreachLink" | "LLMCitation";
  link_domain: string;
  link_title: string | null;
  link_page_url: string | null;
  built_link_url?: string | null;
  notes: string | null;
  probability: number | null;
  category: string | null;
  name: string | null;
  focus_keyword: string | null;
  ranking_url: string | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  examples: (string | null)[];
}

export type Tasks = Task[];

export interface TaskAttributes {
  status?: "TODO" | "DOING" | "DONE";
  built_link_url?: string;
  notes?: string;
}

export interface PageMeta {
  id: number;
  customization_id: number | null;
  kind: "titles" | "descriptions" | "schemas" | "kinds" | "summary";
  source: "auto" | "manual" | "regenerate";
  /** @format date-time */
  created_at: string;
  content: string;
  edited_content: string | null;
  lang: string | null;
}

export type PageMetas = PageMeta[];

export interface UserIntercom {
  intercom_user_jwt: string;
}

export interface AccessTokensResponse {
  access_tokens: AccessTokens;
}

export interface AccessTokenResponse {
  access_token: AccessToken;
}

export interface InvitationsResponse {
  invitations: Invitations;
}

export interface InvitationResponse {
  invitation: Invitation;
}

export interface MembershipsResponse {
  memberships: Memberships;
}

export interface UserNotificationsResponse {
  user_notifications: UserNotifications;
}

export interface ReportRecipientListsResponse {
  report_recipient_lists: ReportRecipientLists;
}

export interface ReportRecipientListResponse {
  report_recipient_list: ReportRecipientList;
}

export interface CurrentSessionResponse {
  current_session: CurrentSession;
}

export interface TeamsResponse {
  teams: Teams;
}

export interface TeamResponse {
  team: Team;
}

export interface TeamUsageResponse {
  team_usage: TeamUsage;
}

export interface UserIdentitiesResponse {
  user_identities: UserIdentities;
}

export interface UserResponse {
  user: User;
}

export interface UserIntercomResponse {
  user_intercom: UserIntercom;
}

export interface PaymentsInvoicesResponse {
  "payments/invoices": PaymentsInvoices;
}

export interface PaymentsInvoiceUrlResponse {
  "payments/invoice_url": PaymentsInvoiceUrl;
}

export interface PaymentsInvoiceUpcomingResponse {
  "payments/invoice_upcoming": PaymentsInvoiceUpcoming;
}

export interface PaymentsOfferResponse {
  "payments/offer": PaymentsOffer;
}

export interface PaymentsOrdersResponse {
  "payments/orders": PaymentsOrders;
}

export interface PaymentsOrderResponse {
  "payments/order": PaymentsOrder;
}

export interface PaymentsOrdersStatsResponse {
  "payments/orders_stats": PaymentsOrdersStats;
}

export interface PaymentsProductsResponse {
  "payments/products": PaymentsProducts;
}

export interface PaymentsSessionResponse {
  "payments/session": PaymentsSession;
}

export interface PaymentsSubscriptionLinkResponse {
  "payments/subscription_link": PaymentsSubscriptionLink;
}

export interface PaymentsSubscriptionResponse {
  "payments/subscription": PaymentsSubscription;
}

export interface CrsRulesResponse {
  crs_rules: CrsRules;
}

export interface CrsRuleResponse {
  crs_rule: CrsRule;
}

export interface CertificateOrdersResponse {
  certificate_orders: CertificateOrders;
}

export interface CertificateOrderResponse {
  certificate_order: CertificateOrder;
}

export interface CertificatesResponse {
  certificates: Certificates;
}

export interface DomainsResponse {
  domains: Domains;
}

export interface DomainResponse {
  domain: Domain;
}

export interface ZoneImportResponse {
  zone_import: ZoneImport;
}

export interface DomainOriginsResponse {
  domain_origins: DomainOrigins;
}

export interface DnsConfigResponse {
  dns_config: DnsConfig;
}

export interface NsHostsStateResponse {
  ns_hosts_state: NsHostsState;
}

export interface RoutingHostsStateResponse {
  routing_hosts_state: RoutingHostsState;
}

export interface LocationsResponse {
  locations: Locations;
}

export interface MfaResponse {
  mfa: Mfa;
}

export interface MfaEnrollmentResponse {
  mfa_enrollment: MfaEnrollment;
}

export interface ClientReportRecipientsResponse {
  client_report_recipients: ClientReportRecipients;
}

export interface ClientReportRecipientResponse {
  client_report_recipient: ClientReportRecipient;
}

export interface ClientReportScheduleResponse {
  client_report_schedule: ClientReportSchedule;
}

export interface ExportsResponse {
  exports: Exports;
}

export interface ExportResponse {
  export: Export;
}

export interface KeywordImportsResponse {
  keyword_imports: KeywordImports;
}

export interface KeywordImportResponse {
  keyword_import: KeywordImport;
}

export interface KeywordMonthlySearchesResponse {
  keyword_monthly_searches: KeywordMonthlySearches;
}

export interface KeywordSuggestionsResponse {
  keyword_suggestions: KeywordSuggestions;
}

export interface KeywordsResponse {
  keywords: Keywords;
}

export interface KeywordResponse {
  keyword: Keyword;
}

export interface KeywordRankingResponse {
  keyword_ranking: KeywordRanking;
}

export interface KeywordHistoricalRankingResponse {
  keyword_historical_ranking: KeywordHistoricalRanking;
}

export interface PageImportResponse {
  page_import: PageImport;
}

export interface WidgetCustomizationResponse {
  "widget/customization": WidgetCustomization;
}

export interface PageMetasResponse {
  page_metas: PageMetas;
}

export interface PagesResponse {
  pages: Pages;
}

export interface PageResponse {
  page: Page;
}

export interface PageCustomizationsResponse {
  page_customizations: PageCustomizations;
}

export interface PageAutomationsResponse {
  page_automations: PageAutomations;
}

export interface PageStatusStatsResponse {
  page_status_stats: PageStatusStats;
}

export interface PageTypeStatsResponse {
  page_type_stats: PageTypeStats;
}

export interface ProxyRequestsResponse {
  proxy_requests: ProxyRequests;
}

export interface SiteCustomizationActionsResponse {
  site_customization_actions: SiteCustomizationActions;
}

export interface SiteCustomizationActionResponse {
  site_customization_action: SiteCustomizationAction;
}

export interface SiteDashboardsResponse {
  site_dashboards: SiteDashboards;
}

export interface SiteDashboardResponse {
  site_dashboard: SiteDashboard;
}

export interface SiteDashboardViewResponse {
  site_dashboard_view: SiteDashboardView;
}

export interface SiteErrorTimeSeriesResponse {
  site_error_time_series: SiteErrorTimeSeries;
}

export interface SiteErrorBreakdownResponse {
  site_error_breakdown: SiteErrorBreakdown;
}

export interface SiteIntegrationsResponse {
  site_integrations: SiteIntegrations;
}

export interface SiteIntegrationResponse {
  site_integration: SiteIntegration;
}

export interface SiteIntegrationConfigurationResponse {
  site_integration_configuration: SiteIntegrationConfiguration;
}

export interface SitePerformanceReportsResponse {
  site_performance_reports: SitePerformanceReports;
}

export interface SiteVisibilityReportsResponse {
  site_visibility_reports: SiteVisibilityReports;
}

export interface SiteVisitorBreakdownResponse {
  site_visitor_breakdown: SiteVisitorBreakdown;
}

export interface SiteVisitTimeSeriesResponse {
  site_visit_time_series: SiteVisitTimeSeries;
}

export interface SiteWafDirectivesResponse {
  site_waf_directives: SiteWafDirectives;
}

export interface SiteWafDirectiveResponse {
  site_waf_directive: SiteWafDirective;
}

export interface SiteWafTimeSeriesResponse {
  site_waf_time_series: SiteWafTimeSeries;
}

export interface SiteWafBreakdownResponse {
  site_waf_breakdown: SiteWafBreakdown;
}

export interface SitesResponse {
  sites: Sites;
}

export interface SiteResponse {
  site: Site;
}

export interface RegionsResponse {
  regions: Regions;
}

export interface LanguagesResponse {
  languages: Languages;
}

export interface SiteGoalsResponse {
  site_goals: SiteGoals;
}

export interface SiteDailyGoalsResponse {
  site_daily_goals: SiteDailyGoals;
}

export interface SiteStatsResponse {
  site_stats: SiteStats;
}

export interface SiteWidgetResponse {
  site_widget: SiteWidget;
}

export interface TasksResponse {
  tasks: Tasks;
}

export interface TaskResponse {
  task: Task;
}

export interface TenantAccountResponse {
  tenant_account: TenantAccount;
}

export interface TenantHostnamesResponse {
  tenant_hostnames: TenantHostnames;
}

export interface WidgetCategoriesResponse {
  "widget/categories": WidgetCategories;
}

export interface WidgetCategoriesStatsResponse {
  "widget/categories_stats": WidgetCategoriesStats;
}

export interface WidgetCustomizationActionsResponse {
  "widget/customization_actions": WidgetCustomizationActions;
}

export interface WidgetCustomizationActionResponse {
  "widget/customization_action": WidgetCustomizationAction;
}

export interface WidgetCustomizationsResponse {
  "widget/customizations": WidgetCustomizations;
}

export interface WidgetCustomizationStatsResponse {
  "widget/customization_stats": WidgetCustomizationStats;
}

export interface WidgetRecommendationActionsResponse {
  "widget/recommendation_actions": WidgetRecommendationActions;
}

export interface WidgetRecommendationActionResponse {
  "widget/recommendation_action": WidgetRecommendationAction;
}

export interface WidgetRecommendationResponse {
  "widget/recommendation": WidgetRecommendation;
}

export interface WidgetRecommendationsResponse {
  "widget/recommendations": WidgetRecommendations;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://{host}/api/ui/v1";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Website API
 * @version v1
 * @baseUrl https://{host}/api/ui/v1
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  accessTokens = {
    /**
     * No description
     *
     * @tags Access Tokens
     * @name AccessTokensList
     * @summary Retrieves Team Access Tokens
     * @request GET:/access_tokens
     * @secure
     */
    accessTokensList: (
      query?: {
        /** @example "created_at ASC, updated_at ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<AccessTokensResponse, any>({
        path: `/access_tokens`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Tokens
     * @name AccessTokensCreate
     * @summary Creates Access Token
     * @request POST:/access_tokens
     * @secure
     */
    accessTokensCreate: (params: RequestParams = {}) =>
      this.http.request<AccessTokenResponse, any>({
        path: `/access_tokens`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Tokens
     * @name AccessTokensDelete
     * @summary Deletes Access Token
     * @request DELETE:/access_tokens/{id}
     * @secure
     */
    accessTokensDelete: (id: number, params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/access_tokens/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  demoLogin = {
    /**
     * No description
     *
     * @tags Account / Demo Logins
     * @name ConfirmCreate
     * @summary Confirms a demo magic-login token and signs the user in
     * @request POST:/demo_login/confirm
     */
    confirmCreate: (data: DemoLoginConfirm, params: RequestParams = {}) =>
      this.http.request<AccessTokenResponse, Error>({
        path: `/demo_login/confirm`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  invitations = {
    /**
     * No description
     *
     * @tags Account / Team Member Invitations
     * @name InvitationsList
     * @summary Retrieves Team Member Invitations
     * @request GET:/invitations
     * @secure
     */
    invitationsList: (
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
        q?: {
          email_eq?: string;
          admin_eq?: boolean;
        };
        /** @example "email ASC, admin ASC" */
        s?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<InvitationsResponse, any>({
        path: `/invitations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Team Member Invitations
     * @name InvitationsCreate
     * @summary Create Team Member Invitation
     * @request POST:/invitations
     * @secure
     */
    invitationsCreate: (
      data: InvitationAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<InvitationResponse, any>({
        path: `/invitations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Team Member Invitations
     * @name InvitationsDelete
     * @summary Cancel Invitation
     * @request DELETE:/invitations/{id}
     * @secure
     */
    invitationsDelete: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/invitations/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Team Member Invitations
     * @name AcceptCreate
     * @summary Accept Invitation Email
     * @request POST:/invitations/{uuid}/accept
     * @secure
     */
    acceptCreate: (uuid: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/invitations/${uuid}/accept`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Team Member Invitations
     * @name ResendCreate
     * @summary Resend Invitation Email
     * @request POST:/invitations/{id}/resend
     * @secure
     */
    resendCreate: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/invitations/${id}/resend`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  memberships = {
    /**
     * No description
     *
     * @tags Account / Members
     * @name MembershipsList
     * @summary Retrieves Memberships
     * @request GET:/memberships
     * @secure
     */
    membershipsList: (
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
        q?: {
          admin_eq?: boolean;
          user_first_name_eq?: string;
          user_last_name_eq?: string;
          user_email_eq?: string;
        };
        /** @example "admin ASC, user_first_name ASC, user_last_name ASC, user_email ASC" */
        s?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<MembershipsResponse, any>({
        path: `/memberships`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Members
     * @name MembershipsDetail
     * @summary Retrieves Membership
     * @request GET:/memberships/{id}
     * @secure
     */
    membershipsDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/memberships/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Members
     * @name MembershipsPartialUpdate
     * @summary Updates Membership
     * @request PATCH:/memberships/{id}
     * @secure
     */
    membershipsPartialUpdate: (
      id: number,
      data: MembershipAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/memberships/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Members
     * @name MembershipsDelete
     * @summary Removes Membership
     * @request DELETE:/memberships/{id}
     * @secure
     */
    membershipsDelete: (id: number, params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/memberships/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Members
     * @name PromoteCreate
     * @summary Promotes Membership
     * @request POST:/memberships/{id}/promote
     * @secure
     */
    promoteCreate: (
      id: number,
      data: MembershipAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/memberships/${id}/promote`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Members
     * @name DemoteCreate
     * @summary Promotes Membership
     * @request POST:/memberships/{id}/demote
     * @secure
     */
    demoteCreate: (
      id: number,
      data: MembershipAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/memberships/${id}/demote`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  notifications = {
    /**
     * No description
     *
     * @tags Account / Notifications
     * @name NotificationsList
     * @summary Retrieves Notifications
     * @request GET:/notifications
     * @secure
     */
    notificationsList: (
      query?: {
        q?: {
          id_eq?: number;
          /** @format date-time */
          read_at_gteq?: string;
          /** @format date-time */
          read_at_lteq?: string;
          /** @format date-time */
          created_at_gteq?: string;
          /** @format date-time */
          created_at_lteq?: string;
        };
        /** @example "id ASC, read_at ASC, created_at ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<UserNotificationsResponse, any>({
        path: `/notifications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Notifications
     * @name SeenCreate
     * @summary Marks all unlread Notifications as read
     * @request POST:/notifications/seen
     * @secure
     */
    seenCreate: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/notifications/seen`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Notifications
     * @name SeenCreate2
     * @summary Markes unread Notification as read
     * @request POST:/notifications/{id}/seen
     * @originalName seenCreate
     * @duplicate
     * @secure
     */
    seenCreate2: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/notifications/${id}/seen`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  password = {
    /**
     * No description
     *
     * @tags Account / Passwords
     * @name PasswordCreate
     * @summary Sends reset password email
     * @request POST:/password
     * @secure
     */
    passwordCreate: (data: PasswordRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Passwords
     * @name PasswordPartialUpdate
     * @summary Confirms password change
     * @request PATCH:/password
     * @secure
     */
    passwordPartialUpdate: (data: PasswordReset, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/password`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  registration = {
    /**
     * No description
     *
     * @tags Account / Registrations
     * @name RegistrationCreate
     * @summary Registers a Member account
     * @request POST:/registration
     * @secure
     */
    registrationCreate: (data: Registration, params: RequestParams = {}) =>
      this.http.request<AccessTokenResponse, Error>({
        path: `/registration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  reportRecipientLists = {
    /**
     * @description The team's lists of addresses client reports are emailed to. Team admins only.
     *
     * @tags Exports / Client Report
     * @name ReportRecipientListsList
     * @summary Retrieves Report Recipient Lists
     * @request GET:/report_recipient_lists
     * @secure
     */
    reportRecipientListsList: (params: RequestParams = {}) =>
      this.http.request<ReportRecipientListsResponse, Error>({
        path: `/report_recipient_lists`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Up to 50 recipients, each an email address or a name in double quotes followed by the address in angle brackets: `"Dana Scully" <dana@example.com>`. Team admins only.
     *
     * @tags Exports / Client Report
     * @name ReportRecipientListsCreate
     * @summary Creates Report Recipient List
     * @request POST:/report_recipient_lists
     * @secure
     */
    reportRecipientListsCreate: (
      data: ReportRecipientListAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<ReportRecipientListResponse, Error>({
        path: `/report_recipient_lists`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports / Client Report
     * @name ReportRecipientListsDetail
     * @summary Retrieves Report Recipient List
     * @request GET:/report_recipient_lists/{id}
     * @secure
     */
    reportRecipientListsDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<ReportRecipientListResponse, Error>({
        path: `/report_recipient_lists/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports / Client Report
     * @name ReportRecipientListsUpdate
     * @summary Updates Report Recipient List
     * @request PUT:/report_recipient_lists/{id}
     * @secure
     */
    reportRecipientListsUpdate: (
      id: number,
      data: ReportRecipientListAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/report_recipient_lists/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Schedules using the list keep running without it.
     *
     * @tags Exports / Client Report
     * @name ReportRecipientListsDelete
     * @summary Deletes Report Recipient List
     * @request DELETE:/report_recipient_lists/{id}
     * @secure
     */
    reportRecipientListsDelete: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/report_recipient_lists/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  session = {
    /**
     * No description
     *
     * @tags Account / Sessions
     * @name SessionList
     * @summary Retrieves the current session state
     * @request GET:/session
     * @secure
     */
    sessionList: (params: RequestParams = {}) =>
      this.http.request<CurrentSessionResponse, any>({
        path: `/session`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Sessions
     * @name SessionCreate
     * @summary Creates a Member session
     * @request POST:/session
     * @secure
     */
    sessionCreate: (data: Session, params: RequestParams = {}) =>
      this.http.request<AccessTokenResponse, Error>({
        path: `/session`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Sessions
     * @name PostSession
     * @summary Creates a Member session after SSO
     * @request POST:/session/sso
     */
    postSession: (params: RequestParams = {}) =>
      this.http.request<AccessTokenResponse, Error>({
        path: `/session/sso`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  teams = {
    /**
     * No description
     *
     * @tags Account / Teams
     * @name TeamsList
     * @summary Retrieves Current User
     * @request GET:/teams
     * @secure
     */
    teamsList: (params: RequestParams = {}) =>
      this.http.request<TeamsResponse, any>({
        path: `/teams`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Teams
     * @name TeamsCreate
     * @summary Creates Team
     * @request POST:/teams
     * @secure
     */
    teamsCreate: (data: TeamAttributes, params: RequestParams = {}) =>
      this.http.request<TeamResponse, any>({
        path: `/teams`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Teams
     * @name CurrentList
     * @summary Retrieves Current Team
     * @request GET:/teams/current
     * @secure
     */
    currentList: (params: RequestParams = {}) =>
      this.http.request<TeamResponse, any>({
        path: `/teams/current`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Teams
     * @name UsageList
     * @summary Retrieves Current Team Usage Stats
     * @request GET:/teams/usage
     * @secure
     */
    usageList: (params: RequestParams = {}) =>
      this.http.request<TeamUsageResponse, any>({
        path: `/teams/usage`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Teams
     * @name TeamsDetail
     * @summary Retrieves Team
     * @request GET:/teams/{id}
     * @secure
     */
    teamsDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<TeamResponse, Error>({
        path: `/teams/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Teams
     * @name TeamsPartialUpdate
     * @summary Updates Team
     * @request PATCH:/teams/{id}
     * @secure
     */
    teamsPartialUpdate: (
      id: number,
      data: TeamAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/teams/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Teams
     * @name LeaveDelete
     * @summary Leave Team
     * @request DELETE:/teams/{id}/leave
     * @secure
     */
    leaveDelete: (id: number, params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/teams/${id}/leave`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  unlock = {
    /**
     * No description
     *
     * @tags Account / Unlocks
     * @name ConfirmCreate
     * @summary Confirms account unlock and signs the user in
     * @request POST:/unlock/confirm
     * @secure
     */
    confirmCreate: (data: UnlockConfirm, params: RequestParams = {}) =>
      this.http.request<AccessTokenResponse, void>({
        path: `/unlock/confirm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  userIdentities = {
    /**
     * No description
     *
     * @tags Account / Identities
     * @name UserIdentitiesList
     * @summary Retrieves Current User Identities
     * @request GET:/user_identities
     * @secure
     */
    userIdentitiesList: (
      query?: {
        q?: {
          kind_eq?: "auth" | "analytics" | "ext";
          provider_eq?: "google_oauth2";
        };
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<UserIdentitiesResponse, any>({
        path: `/user_identities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Identities
     * @name UserIdentitiesCreate
     * @summary Creates a User Identity
     * @request POST:/user_identities
     * @secure
     */
    userIdentitiesCreate: (
      data: UserIdentityAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/user_identities`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account / Identities
     * @name UserIdentitiesDelete
     * @summary Deletes a User Identity
     * @request DELETE:/user_identities/{id}
     * @secure
     */
    userIdentitiesDelete: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/user_identities/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags Accounts
     * @name UserList
     * @summary Retrieves Current User
     * @request GET:/user
     * @secure
     */
    userList: (params: RequestParams = {}) =>
      this.http.request<UserResponse, any>({
        path: `/user`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name UserPartialUpdate
     * @summary Updates Current User
     * @request PATCH:/user
     * @secure
     */
    userPartialUpdate: (data: UserAttributes, params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/user`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name IntercomJwtList
     * @summary Retrieves Current User Intercom Hash
     * @request GET:/user/intercom_jwt
     * @secure
     */
    intercomJwtList: (params: RequestParams = {}) =>
      this.http.request<UserIntercomResponse, void>({
        path: `/user/intercom_jwt`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  billing = {
    /**
     * No description
     *
     * @tags Billing / Invoices
     * @name InvoicesList
     * @summary Retrieves Invoices
     * @request GET:/billing/invoices
     * @secure
     */
    invoicesList: (
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
        q?: {
          number_eq?: string;
          status_eq?: "draft" | "open" | "paid" | "uncollectible" | "void";
        };
        /** @example "number ASC, status ASC, total ASC, period_start ASC, period_end ASC, created_at ASC" */
        s?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PaymentsInvoicesResponse, any>({
        path: `/billing/invoices`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Invoices
     * @name InvoicesViewDetail
     * @summary Retrieves Invoice View URL (temporary)
     * @request GET:/billing/invoices/{id}/view
     * @secure
     */
    invoicesViewDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<PaymentsInvoiceUrlResponse, any>({
        path: `/billing/invoices/${id}/view`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Invoices
     * @name InvoicesDownloadDetail
     * @summary Retrieves Invoice Download URL (temporary)
     * @request GET:/billing/invoices/{id}/download
     * @secure
     */
    invoicesDownloadDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<PaymentsInvoiceUrlResponse, any>({
        path: `/billing/invoices/${id}/download`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Invoices
     * @name InvoicesUpcomingList
     * @summary Retrieves Upcoming Invoice
     * @request GET:/billing/invoices/upcoming
     * @secure
     */
    invoicesUpcomingList: (params: RequestParams = {}) =>
      this.http.request<PaymentsInvoiceUpcomingResponse, any>({
        path: `/billing/invoices/upcoming`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Offers
     * @name OffersPurchaseCreate
     * @summary Buys an Autopto offer with the saved card
     * @request POST:/billing/offers/{key}/purchase
     * @secure
     */
    offersPurchaseCreate: (key: string, params: RequestParams = {}) =>
      this.http.request<PaymentsOfferResponse, Error>({
        path: `/billing/offers/${key}/purchase`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Offers
     * @name OffersDeclineCreate
     * @summary Declines an Autopto offer
     * @request POST:/billing/offers/{key}/decline
     * @secure
     */
    offersDeclineCreate: (key: string, params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/billing/offers/${key}/decline`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Orders
     * @name OrdersList
     * @summary Retrieves team orders
     * @request GET:/billing/orders
     * @secure
     */
    ordersList: (
      query: {
        /** @default null */
        type: "links" | "concierge" | "active";
        q?: {
          status_eq?: "pending" | "failed" | "canceled" | "succeeded";
        };
        /** @example "created_at ASC, completed_at ASC, paid_at ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PaymentsOrdersResponse, any>({
        path: `/billing/orders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Orders
     * @name OrdersCreate
     * @summary Creates Order
     * @request POST:/billing/orders
     * @secure
     */
    ordersCreate: (
      data: PaymentsCreateOrderAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<PaymentsOrderResponse, Error>({
        path: `/billing/orders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Orders
     * @name OrdersStatsList
     * @summary Retrieves team orders count
     * @request GET:/billing/orders/stats
     * @secure
     */
    ordersStatsList: (params: RequestParams = {}) =>
      this.http.request<PaymentsOrdersStatsResponse, any>({
        path: `/billing/orders/stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Orders
     * @name OrdersCancelPartialUpdate
     * @summary Cancel order
     * @request PATCH:/billing/orders/{id}/cancel
     * @secure
     */
    ordersCancelPartialUpdate: (id: number, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/billing/orders/${id}/cancel`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Products
     * @name ProductsList
     * @summary Retrieves products
     * @request GET:/billing/products
     * @secure
     */
    productsList: (
      query?: {
        q?: {
          name_eq?: string;
          kind_eq?: "unknown" | "plan" | "add-on" | "product";
        };
        /** @example "created_at ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PaymentsProductsResponse, any>({
        path: `/billing/products`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Sessions
     * @name SessionSetupCreate
     * @summary Opens Setup Session
     * @request POST:/billing/session/setup
     * @secure
     */
    sessionSetupCreate: (
      data: PaymentsSessionAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<PaymentsSessionResponse, any>({
        path: `/billing/session/setup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Sessions
     * @name SessionCheckoutCreate
     * @summary Opens Checkout Session
     * @request POST:/billing/session/checkout
     * @secure
     */
    sessionCheckoutCreate: (
      data: PaymentsSessionAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<PaymentsSessionResponse, Error>({
        path: `/billing/session/checkout`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Sessions
     * @name SessionPayCreate
     * @summary Opens Order Session
     * @request POST:/billing/session/pay
     * @secure
     */
    sessionPayCreate: (
      data: PaymentsSessionAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<PaymentsSessionResponse, Error>({
        path: `/billing/session/pay`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Sessions
     * @name SessionCancelCreate
     * @summary Cancels All Open Session
     * @request POST:/billing/session/cancel
     * @secure
     */
    sessionCancelCreate: (params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/billing/session/cancel`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Subscription Links
     * @name SubscriptionLinksDetail
     * @summary Retrieves a Subscription Link
     * @request GET:/billing/subscription_links/{code}
     * @secure
     */
    subscriptionLinksDetail: (code: string, params: RequestParams = {}) =>
      this.http.request<PaymentsSubscriptionLinkResponse, Error>({
        path: `/billing/subscription_links/${code}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Subscription Links
     * @name SubscriptionLinksBootstrapCreate
     * @summary Redeems a Subscription Link for a new account
     * @request POST:/billing/subscription_links/{code}/bootstrap
     */
    subscriptionLinksBootstrapCreate: (
      code: string,
      data: SubscriptionLinkRegistration,
      params: RequestParams = {},
    ) =>
      this.http.request<AccessTokenResponse, Error>({
        path: `/billing/subscription_links/${code}/bootstrap`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Subscriptions
     * @name SubscriptionList
     * @summary Retrieves Team Subscription
     * @request GET:/billing/subscription
     * @secure
     */
    subscriptionList: (params: RequestParams = {}) =>
      this.http.request<PaymentsSubscriptionResponse, Error>({
        path: `/billing/subscription`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Subscriptions
     * @name SubscriptionCreate
     * @summary Creates Subscription
     * @request POST:/billing/subscription
     * @secure
     */
    subscriptionCreate: (
      data: PaymentsSubscriptionCreateAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<PaymentsSubscriptionResponse, Error>({
        path: `/billing/subscription`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Subscriptions
     * @name SubscriptionPartialUpdate
     * @summary Updates Subscription
     * @request PATCH:/billing/subscription
     * @secure
     */
    subscriptionPartialUpdate: (
      data: PaymentsSubscriptionUpdateAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/billing/subscription`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Subscriptions
     * @name SubscriptionCancelCreate
     * @summary Cancels Team Subscription (at the billing period end)
     * @request POST:/billing/subscription/cancel
     * @secure
     */
    subscriptionCancelCreate: (
      data: PaymentsSubscriptionCancelAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/billing/subscription/cancel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Subscriptions
     * @name SubscriptionRestoreCreate
     * @summary Restores Team Subscription (removes the cancel at period end flag)
     * @request POST:/billing/subscription/restore
     * @secure
     */
    subscriptionRestoreCreate: (params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/billing/subscription/restore`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Subscriptions
     * @name SubscriptionActivateCreate
     * @summary Ends Trial on Team Subscription
     * @request POST:/billing/subscription/activate
     * @secure
     */
    subscriptionActivateCreate: (params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/billing/subscription/activate`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing / Subscriptions
     * @name SubscriptionSuspendCreate
     * @summary Suspends Team Subscription
     * @request POST:/billing/subscription/suspend
     * @secure
     */
    subscriptionSuspendCreate: (params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/billing/subscription/suspend`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  crsRules = {
    /**
     * No description
     *
     * @tags CRS Rules
     * @name CrsRulesList
     * @summary Retrieves CRS Rules
     * @request GET:/crs_rules
     * @secure
     */
    crsRulesList: (params: RequestParams = {}) =>
      this.http.request<CrsRulesResponse, any>({
        path: `/crs_rules`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CRS Rules
     * @name CrsRulesDetail
     * @summary Retrieves CRS Rule
     * @request GET:/crs_rules/{id}
     * @secure
     */
    crsRulesDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<CrsRuleResponse, void>({
        path: `/crs_rules/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  domains = {
    /**
     * No description
     *
     * @tags Domains / Certificate Orders
     * @name CertificateOrdersDetail
     * @summary Retrieves Certificate Orders
     * @request GET:/domains/{domain_id}/certificate_orders
     * @secure
     */
    certificateOrdersDetail: (
      domainId: number,
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
        q?: {
          site_id_eq?: number;
          status_eq?:
            | "pending"
            | "ordered"
            | "verified"
            | "obtained"
            | "completed"
            | "failed"
            | "expired"
            | "suspended";
        };
        /** @example "created_at ASC" */
        s?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<CertificateOrdersResponse, any>({
        path: `/domains/${domainId}/certificate_orders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains / Certificate Orders
     * @name CertificateOrdersDetail2
     * @summary Retrieves Certificate Order
     * @request GET:/domains/{domain_id}/certificate_orders/{id}
     * @originalName certificateOrdersDetail
     * @duplicate
     * @secure
     */
    certificateOrdersDetail2: (
      domainId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<CertificateOrderResponse, any>({
        path: `/domains/${domainId}/certificate_orders/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains / Certificates
     * @name CertificatesDetail
     * @summary Retrieves Certificates
     * @request GET:/domains/{domain_id}/certificates
     * @secure
     */
    certificatesDetail: (
      domainId: number,
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
        q?: {
          domain_id_eq?: number;
          site_id_eq?: number;
          tenant_hostname_id_eq?: number;
          issuer_eq?: "custom" | "letsencrypt";
          issuer_name_eq?: string;
          subject_eq?: string;
          /** @format date-time */
          not_before_gteq?: string;
          /** @format date-time */
          not_before_lteq?: string;
          /** @format date-time */
          not_after_gteq?: string;
          /** @format date-time */
          not_after_lteq?: string;
          /** @format date-time */
          created_at_gteq?: string;
          /** @format date-time */
          created_at_lteq?: string;
        };
        /** @example "domain_id ASC, site_id ASC, tenant_hostname_id ASC, issuer ASC, not_before ASC, not_after ASC, created_at ASC" */
        s?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<CertificatesResponse, any>({
        path: `/domains/${domainId}/certificates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains / Certificates
     * @name CertificatesAssignedDetail
     * @summary Retrieves Assigned Certificates
     * @request GET:/domains/{domain_id}/certificates/assigned
     * @secure
     */
    certificatesAssignedDetail: (
      domainId: number,
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
        q?: {
          domain_id_eq?: number;
          site_id_eq?: number;
          tenant_hostname_id_eq?: number;
          issuer_eq?: "custom" | "letsencrypt";
          issuer_name_eq?: string;
          subject_eq?: string;
          /** @format date-time */
          not_before_gteq?: string;
          /** @format date-time */
          not_before_lteq?: string;
          /** @format date-time */
          not_after_gteq?: string;
          /** @format date-time */
          not_after_lteq?: string;
          /** @format date-time */
          created_at_gteq?: string;
          /** @format date-time */
          created_at_lteq?: string;
        };
        /** @example "domain_id ASC, site_id ASC, tenant_hostname_id ASC, issuer ASC, not_before ASC, not_after ASC, created_at ASC" */
        s?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<CertificatesResponse, any>({
        path: `/domains/${domainId}/certificates/assigned`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains
     * @name DomainsList
     * @summary Retrieves Domains
     * @request GET:/domains
     * @secure
     */
    domainsList: (
      query?: {
        q?: {
          name_eq?: string;
        };
        /** @example "name ASC, verification_set ASC, ns_set ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DomainsResponse, any>({
        path: `/domains`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains
     * @name DomainsDetail
     * @summary Retrieves Domain
     * @request GET:/domains/{id}
     * @secure
     */
    domainsDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<DomainResponse, Error>({
        path: `/domains/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains
     * @name DomainsPartialUpdate
     * @summary Updates Domain
     * @request PATCH:/domains/{id}
     * @secure
     */
    domainsPartialUpdate: (
      id: number,
      data: DomainUpdateAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/domains/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains
     * @name StatusDetail
     * @summary Refresh Domain Status
     * @request GET:/domains/{id}/status
     * @secure
     */
    statusDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<DomainResponse, any>({
        path: `/domains/${id}/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains
     * @name CertificateCreate
     * @summary Updates Domain Certificate
     * @request POST:/domains/{id}/certificate
     * @secure
     */
    certificateCreate: (
      id: number,
      data: DomainCertificateAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/domains/${id}/certificate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains
     * @name ZoneCreate
     * @summary Parse Uploaded Zone File
     * @request POST:/domains/{id}/zone
     * @secure
     */
    zoneCreate: (
      id: number,
      data: DomainUpdateAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<ZoneImportResponse, any>({
        path: `/domains/${id}/zone`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains
     * @name OriginsDetail
     * @summary Returns Domain Origins Status
     * @request GET:/domains/{id}/origins
     * @secure
     */
    originsDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<DomainOriginsResponse, any>({
        path: `/domains/${id}/origins`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains
     * @name GetDomains
     * @summary Returns the whole Domain DNS configuration for known hosts
     * @request GET:/domains/{id}/dns
     * @secure
     */
    getDomains: (id: number, params: RequestParams = {}) =>
      this.http.request<DnsConfigResponse, any>({
        path: `/domains/${id}/dns`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains
     * @name NsHostsStateDetail
     * @summary Returns Domain Nameservers Hosts State
     * @request GET:/domains/{id}/ns_hosts_state
     * @secure
     */
    nsHostsStateDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<NsHostsStateResponse, any>({
        path: `/domains/${id}/ns_hosts_state`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domains
     * @name RoutingHostsStateDetail
     * @summary Returns Domain Routing Hosts State
     * @request GET:/domains/{id}/routing_hosts_state
     * @secure
     */
    routingHostsStateDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<RoutingHostsStateResponse, any>({
        path: `/domains/${id}/routing_hosts_state`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  locations = {
    /**
     * No description
     *
     * @tags Locations
     * @name LocationsList
     * @summary Top-Level Locations (Countries)
     * @request GET:/locations
     * @secure
     */
    locationsList: (
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LocationsResponse, any>({
        path: `/locations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name SearchList
     * @summary Searches Location
     * @request GET:/locations/search
     * @secure
     */
    searchList: (
      query: {
        fulltext: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LocationsResponse, any>({
        path: `/locations/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  mfa = {
    /**
     * No description
     *
     * @tags MFA
     * @name GetMfa
     * @summary Retrieves MFA enrollment status
     * @request GET:/mfa
     * @secure
     */
    getMfa: (params: RequestParams = {}) =>
      this.http.request<MfaResponse, any>({
        path: `/mfa`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MFA
     * @name PostMfa
     * @summary Enrolls in MFA
     * @request POST:/mfa
     * @secure
     */
    postMfa: (data: MfaOtp, params: RequestParams = {}) =>
      this.http.request<MfaEnrollmentResponse, Error>({
        path: `/mfa`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MFA
     * @name DeleteMfa
     * @summary Disables MFA
     * @request DELETE:/mfa
     * @secure
     */
    deleteMfa: (data: MfaPassword, params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/mfa`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MFA
     * @name VerifyCreate
     * @summary Verifies MFA for the current session
     * @request POST:/mfa/verify
     * @secure
     */
    verifyCreate: (data: MfaOtp, params: RequestParams = {}) =>
      this.http.request<CurrentSessionResponse, Error>({
        path: `/mfa/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  oauth = {
    /**
     * No description
     *
     * @tags Oauth / Google
     * @name GoogleCreate
     * @summary Google OAuth: exchange code → create/attach identity → sign in
     * @request POST:/oauth/google
     * @secure
     */
    googleCreate: (data: UserIdentityAttributes, params: RequestParams = {}) =>
      this.http.request<AccessTokenResponse, any>({
        path: `/oauth/google`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  sites = {
    /**
     * @description Team members who get the site's client reports by email.
     *
     * @tags Exports / Client Report
     * @name ClientReportRecipientsDetail
     * @summary Retrieves Client Report Recipients
     * @request GET:/sites/{site_id}/client_report_recipients
     * @secure
     */
    clientReportRecipientsDetail: (
      siteId: number,
      params: RequestParams = {},
    ) =>
      this.http.request<ClientReportRecipientsResponse, any>({
        path: `/sites/${siteId}/client_report_recipients`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Team admins only. The member must have access to the site. White-label users get the email from the agency's white-label profile, everyone else from the regular sender.
     *
     * @tags Exports / Client Report
     * @name ClientReportRecipientsCreate
     * @summary Adds Client Report Recipient
     * @request POST:/sites/{site_id}/client_report_recipients
     * @secure
     */
    clientReportRecipientsCreate: (
      siteId: number,
      data: {
        membership_id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ClientReportRecipientResponse, Error>({
        path: `/sites/${siteId}/client_report_recipients`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports / Client Report
     * @name ClientReportRecipientsDelete
     * @summary Removes Client Report Recipient
     * @request DELETE:/sites/{site_id}/client_report_recipients/{id}
     * @secure
     */
    clientReportRecipientsDelete: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/client_report_recipients/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports / Client Report
     * @name ClientReportScheduleDetail
     * @summary Retrieves Client Report Schedule
     * @request GET:/sites/{site_id}/client_report_schedule
     * @secure
     */
    clientReportScheduleDetail: (siteId: number, params: RequestParams = {}) =>
      this.http.request<ClientReportScheduleResponse, Error>({
        path: `/sites/${siteId}/client_report_schedule`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a client report on a day of the month, covering the previous calendar month, or on a day of the week, covering the 7 days before, and emails it to the site's report recipients and to the recipient list, if one is chosen. The first report comes on the next matching day after today. Team admins only.
     *
     * @tags Exports / Client Report
     * @name ClientReportScheduleCreate
     * @summary Creates Client Report Schedule
     * @request POST:/sites/{site_id}/client_report_schedule
     * @secure
     */
    clientReportScheduleCreate: (
      siteId: number,
      data: ClientReportScheduleAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<ClientReportScheduleResponse, Error>({
        path: `/sites/${siteId}/client_report_schedule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports / Client Report
     * @name ClientReportScheduleUpdate
     * @summary Updates Client Report Schedule
     * @request PUT:/sites/{site_id}/client_report_schedule
     * @secure
     */
    clientReportScheduleUpdate: (
      siteId: number,
      data: ClientReportScheduleAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/client_report_schedule`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports / Client Report
     * @name ClientReportScheduleDelete
     * @summary Deletes Client Report Schedule
     * @request DELETE:/sites/{site_id}/client_report_schedule
     * @secure
     */
    clientReportScheduleDelete: (siteId: number, params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/client_report_schedule`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportsDetail
     * @summary Retrieves Site Exports
     * @request GET:/sites/{site_id}/exports
     * @secure
     */
    exportsDetail: (
      siteId: number,
      query?: {
        q?: {
          status_eq?:
            | "created"
            | "processing"
            | "completed"
            | "failed"
            | "canceled";
          type_eq?:
            | "BuiltLinkExport"
            | "ClientReport"
            | "KeywordExport"
            | "SiteSalesReport"
            | "WorkDoneReport"
            | "Widget::RecommendationExport";
        };
        /** @example "created_at ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ExportsResponse, any>({
        path: `/sites/${siteId}/exports`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportsDetail2
     * @summary Retrieves Export
     * @request GET:/sites/{site_id}/exports/{id}
     * @originalName exportsDetail
     * @duplicate
     * @secure
     */
    exportsDetail2: (siteId: number, id: number, params: RequestParams = {}) =>
      this.http.request<ExportResponse, Error>({
        path: `/sites/${siteId}/exports/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportsCancelCreate
     * @summary Cancels Export
     * @request POST:/sites/{site_id}/exports/{id}/cancel
     * @secure
     */
    exportsCancelCreate: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/exports/${id}/cancel`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports / Site Recommendation
     * @name RecommendationExportsCreate
     * @summary Creates Site Recommendation Export
     * @request POST:/sites/{site_id}/recommendation_exports
     * @secure
     */
    recommendationExportsCreate: (siteId: number, params: RequestParams = {}) =>
      this.http.request<ExportResponse, Error>({
        path: `/sites/${siteId}/recommendation_exports`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports / Built Link
     * @name BuiltLinkExportsCreate
     * @summary Creates Site Built Link Export
     * @request POST:/sites/{site_id}/built_link_exports
     * @secure
     */
    builtLinkExportsCreate: (siteId: number, params: RequestParams = {}) =>
      this.http.request<ExportResponse, Error>({
        path: `/sites/${siteId}/built_link_exports`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports / Site Sales
     * @name SalesReportsCreate
     * @summary Creates Site Sales Export
     * @request POST:/sites/{site_id}/sales_reports
     * @secure
     */
    salesReportsCreate: (siteId: number, params: RequestParams = {}) =>
      this.http.request<ExportResponse, Error>({
        path: `/sites/${siteId}/sales_reports`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports / Keyword
     * @name KeywordExportsCreate
     * @summary Creates Site Keyword Export
     * @request POST:/sites/{site_id}/keyword_exports
     * @secure
     */
    keywordExportsCreate: (siteId: number, params: RequestParams = {}) =>
      this.http.request<ExportResponse, Error>({
        path: `/sites/${siteId}/keyword_exports`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports / Work Done
     * @name WorkDoneReportsCreate
     * @summary Creates Site Work Done Export
     * @request POST:/sites/{site_id}/work_done_reports
     * @secure
     */
    workDoneReportsCreate: (siteId: number, params: RequestParams = {}) =>
      this.http.request<ExportResponse, Error>({
        path: `/sites/${siteId}/work_done_reports`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description A report for the period, compared with the previous period of the same length. The period defaults to the month that ended yesterday. With `email`, the PDF is emailed to the site's report recipients and to the recipient list, if one is given, once ready; only team admins can email a report.
     *
     * @tags Exports / Client Report
     * @name ClientReportsCreate
     * @summary Creates Site Client Report
     * @request POST:/sites/{site_id}/client_reports
     * @secure
     */
    clientReportsCreate: (
      siteId: number,
      data: {
        /** @format date */
        starts_on?: string;
        /** @format date */
        ends_on?: string;
        email?: boolean;
        report_recipient_list_id?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ExportResponse, Error>({
        path: `/sites/${siteId}/client_reports`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keyword Imports
     * @name KeywordImportsDetail
     * @summary Retrieves Site Keyword Imports
     * @request GET:/sites/{site_id}/keyword_imports
     * @secure
     */
    keywordImportsDetail: (
      siteId: number,
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
        /** @example "created_at ASC" */
        s?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<KeywordImportsResponse, any>({
        path: `/sites/${siteId}/keyword_imports`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keyword Imports
     * @name KeywordImportsCreate
     * @summary Creates Site Keyword Import
     * @request POST:/sites/{site_id}/keyword_imports
     * @secure
     */
    keywordImportsCreate: (
      siteId: number,
      data: KeywordImportAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<KeywordImportResponse, any>({
        path: `/sites/${siteId}/keyword_imports`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keyword Imports
     * @name KeywordImportsDetail2
     * @summary Retrieves Keyword Import
     * @request GET:/sites/{site_id}/keyword_imports/{id}
     * @originalName keywordImportsDetail
     * @duplicate
     * @secure
     */
    keywordImportsDetail2: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<KeywordImportResponse, any>({
        path: `/sites/${siteId}/keyword_imports/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keyword Monthly Searches
     * @name KeywordsMonthlySearchesDetail
     * @summary Retrieves Keyword monthly Searches
     * @request GET:/sites/{site_id}/keywords/{keyword_id}/monthly_searches
     * @secure
     */
    keywordsMonthlySearchesDetail: (
      siteId: number,
      keywordId: number,
      query?: {
        /** @example "id ASC, year ASC, month ASC, volume ASC, created_at ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<KeywordMonthlySearchesResponse, any>({
        path: `/sites/${siteId}/keywords/${keywordId}/monthly_searches`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keyword Suggestions
     * @name KeywordSuggestionsDetail
     * @summary Retrieves Site Keyword Suggestions
     * @request GET:/sites/{site_id}/keyword_suggestions
     * @secure
     */
    keywordSuggestionsDetail: (
      siteId: number,
      query?: {
        q?: {
          name_eq?: string;
          /** @format float */
          alli_score_eq?: number;
          /** @format double */
          alli_rating_eq?: number;
          pos_eq?: number;
          /** @format float */
          cpc_eq?: number;
          /** @format float */
          cmp_eq?: number;
          msv_eq?: number;
        };
        /** @example "name ASC, alli_score ASC, alli_rating ASC, pos ASC, cpc ASC, cmp ASC, msv ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<KeywordSuggestionsResponse, any>({
        path: `/sites/${siteId}/keyword_suggestions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keywords
     * @name KeywordsDetail
     * @summary Retrieves Site Keywords
     * @request GET:/sites/{site_id}/keywords
     * @secure
     */
    keywordsDetail: (
      siteId: number,
      query?: {
        q?: {
          name_eq?: string;
          language_eq?: string;
          country_eq?: string;
          /** @format float */
          alli_score_eq?: number;
          /** @format double */
          alli_rating_eq?: number;
          start_pos_eq?: number;
          now_pos_eq?: number;
          /** @format float */
          cpc_eq?: number;
          /** @format float */
          cmp_eq?: number;
          search_vol_eq?: number;
          day_change_eq?: number;
          week_change_eq?: number;
          month_change_eq?: number;
          life_change_eq?: number;
        };
        /** @example "name ASC, language ASC, country ASC, alli_score ASC, alli_rating ASC, start_pos ASC, now_pos ASC, cpc ASC, cmp ASC, search_vol ASC, day_change ASC, week_change ASC, month_change ASC, life_change ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<KeywordsResponse, any>({
        path: `/sites/${siteId}/keywords`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keywords
     * @name KeywordsCreate
     * @summary Creates Site Keyword
     * @request POST:/sites/{site_id}/keywords
     * @secure
     */
    keywordsCreate: (
      siteId: number,
      data: KeywordAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<KeywordResponse, Error>({
        path: `/sites/${siteId}/keywords`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keywords
     * @name KeywordsTopDetail
     * @summary Retrieves TOP 5 Keywords
     * @request GET:/sites/{site_id}/keywords/top
     * @secure
     */
    keywordsTopDetail: (
      siteId: number,
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<KeywordsResponse, any>({
        path: `/sites/${siteId}/keywords/top`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keywords
     * @name KeywordsBulkPartialUpdate
     * @summary Bulk Update Site Keyword
     * @request PATCH:/sites/{site_id}/keywords/bulk
     * @secure
     */
    keywordsBulkPartialUpdate: (
      siteId: number,
      data: KeywordBulkUpdateAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/keywords/bulk`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keywords
     * @name KeywordsBulkDelete
     * @summary Bulk Delete Site Keyword
     * @request DELETE:/sites/{site_id}/keywords/bulk
     * @secure
     */
    keywordsBulkDelete: (
      siteId: number,
      data: KeywordBulkDeleteAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/sites/${siteId}/keywords/bulk`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keywords
     * @name KeywordsDetail2
     * @summary Retrieves Site Keyword
     * @request GET:/sites/{site_id}/keywords/{id}
     * @originalName keywordsDetail
     * @duplicate
     * @secure
     */
    keywordsDetail2: (siteId: number, id: number, params: RequestParams = {}) =>
      this.http.request<KeywordResponse, Error>({
        path: `/sites/${siteId}/keywords/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keywords
     * @name KeywordsPartialUpdate
     * @summary Updates Site Keyword
     * @request PATCH:/sites/{site_id}/keywords/{id}
     * @secure
     */
    keywordsPartialUpdate: (
      siteId: number,
      id: number,
      data: KeywordAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/keywords/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keywords
     * @name KeywordsDelete
     * @summary Deletes Keyword
     * @request DELETE:/sites/{site_id}/keywords/{id}
     * @secure
     */
    keywordsDelete: (siteId: number, id: number, params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/keywords/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keywords
     * @name KeywordsFocusCreate
     * @summary Sets Site Focus Keyword
     * @request POST:/sites/{site_id}/keywords/{id}/focus
     * @secure
     */
    keywordsFocusCreate: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/keywords/${id}/focus`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keywords
     * @name KeywordsRefreshCreate
     * @summary Refresh Keyword Rank
     * @request POST:/sites/{site_id}/keywords/{id}/refresh
     * @secure
     */
    keywordsRefreshCreate: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/keywords/${id}/refresh`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keywords
     * @name KeywordsRankingDetail
     * @summary Keyword Ranking
     * @request GET:/sites/{site_id}/keywords/{id}/ranking
     * @secure
     */
    keywordsRankingDetail: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<KeywordRankingResponse, Error>({
        path: `/sites/${siteId}/keywords/${id}/ranking`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Keywords
     * @name KeywordsHistoricalRankingDetail
     * @summary Keyword Ranking
     * @request GET:/sites/{site_id}/keywords/{id}/historical_ranking
     * @secure
     */
    keywordsHistoricalRankingDetail: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<KeywordHistoricalRankingResponse, Error>({
        path: `/sites/${siteId}/keywords/${id}/historical_ranking`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / PageImports
     * @name PageImportsDetail
     * @summary Retrieves PageImport
     * @request GET:/sites/{site_id}/page_imports/{id}
     * @secure
     */
    pageImportsDetail: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<PageImportResponse, void>({
        path: `/sites/${siteId}/page_imports/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / PageImports
     * @name PageImportsRetryCreate
     * @summary Retries PageImport
     * @request POST:/sites/{site_id}/page_imports/{id}/retry
     * @secure
     */
    pageImportsRetryCreate: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/sites/${siteId}/page_imports/${id}/retry`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Pages / PageMetas
     * @name PagesPageMetasGenerateCustomizationCreate
     * @summary Generates Customization from PageMeta
     * @request POST:/sites/{site_id}/pages/{page_id}/page_metas/{id}/generate_customization
     * @secure
     */
    pagesPageMetasGenerateCustomizationCreate: (
      siteId: number,
      pageId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetCustomizationResponse, Error>({
        path: `/sites/${siteId}/pages/${pageId}/page_metas/${id}/generate_customization`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Pages / PageMetas
     * @name PagesPageMetasDetail
     * @summary Retrieves Page PageMetas
     * @request GET:/sites/{site_id}/pages/{page_id}/page_metas/{kind}
     * @secure
     */
    pagesPageMetasDetail: (
      siteId: number,
      pageId: number,
      kind: "titles" | "descriptions" | "schemas" | "summary",
      params: RequestParams = {},
    ) =>
      this.http.request<PageMetasResponse, Error | void>({
        path: `/sites/${siteId}/pages/${pageId}/page_metas/${kind}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Pages
     * @name PagesDetail
     * @summary Retrieves Site Pages
     * @request GET:/sites/{site_id}/pages
     * @secure
     */
    pagesDetail: (
      siteId: number,
      query?: {
        q?: {
          id_eq?: number;
          status_eq?:
            | "pending"
            | "in_progress"
            | "failed"
            | "completed"
            | "ignored"
            | "incompatible"
            | "unreachable"
            | "noindex"
            | "duplicate"
            | "offsite"
            | "excluded";
          kind_eq?:
            | "unknown"
            | "unidentified"
            | "article"
            | "event"
            | "faq"
            | "organization"
            | "person"
            | "product"
            | "video"
            | "job"
            | "contact";
          path_eq?: string;
          query_eq?: string;
          path_and_query_eq?: string;
          page_recommendations_category_id_eq?: number;
          page_recommendations_page_id_eq?: number;
          recommendations_category_id_eq?: number;
          recommendations_active_eq?: boolean;
          recommendations_page_recommendations_category_id_eq?: number;
          recommendations_page_recommendations_page_id_eq?: number;
          status_in?: (
            | "pending"
            | "in_progress"
            | "failed"
            | "completed"
            | "ignored"
            | "incompatible"
            | "unreachable"
            | "noindex"
            | "duplicate"
            | "offsite"
            | "excluded"
          )[];
          status_not_in?: (
            | "pending"
            | "in_progress"
            | "failed"
            | "completed"
            | "ignored"
            | "incompatible"
            | "unreachable"
            | "noindex"
            | "duplicate"
            | "offsite"
            | "excluded"
          )[];
          kind_in?: (
            | "unknown"
            | "unidentified"
            | "article"
            | "event"
            | "faq"
            | "organization"
            | "person"
            | "product"
            | "video"
            | "job"
            | "contact"
          )[];
          kind_not_in?: (
            | "unknown"
            | "unidentified"
            | "article"
            | "event"
            | "faq"
            | "organization"
            | "person"
            | "product"
            | "video"
            | "job"
            | "contact"
          )[];
          path_cont?: string;
          path_not_cont?: string;
          path_start?: string;
          path_not_start?: string;
          path_end?: string;
          path_not_end?: string;
          path_not_eq?: string;
          query_cont?: string;
          query_not_cont?: string;
          query_start?: string;
          query_not_start?: string;
          query_end?: string;
          query_not_end?: string;
          query_not_eq?: string;
          with_customization_kind?: (
            | "title"
            | "description"
            | "schema"
            | "ai_instructions"
          )[];
          without_customization_kind?: (
            | "title"
            | "description"
            | "schema"
            | "ai_instructions"
          )[];
          without_any_customization_kind?: (
            | "title"
            | "description"
            | "schema"
            | "ai_instructions"
          )[];
        };
        /** @example "id ASC, status ASC, kind ASC, path ASC, query ASC, path_and_query ASC, depth ASC, lang ASC, widget_installed ASC, crawled_at ASC, page_recommendations_category_id ASC, page_recommendations_page_id ASC, recommendations_category_id ASC, recommendations_created_at ASC, recommendations_page_recommendations_category_id ASC, recommendations_page_recommendations_page_id ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PagesResponse, any>({
        path: `/sites/${siteId}/pages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Pages
     * @name PagesCreate
     * @summary Creates Custom Page
     * @request POST:/sites/{site_id}/pages
     * @secure
     */
    pagesCreate: (
      siteId: number,
      data: PageCreateAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<PageResponse, Error>({
        path: `/sites/${siteId}/pages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Pages
     * @name PagesCustomizedDetail
     * @summary Retrieves a list of pages with Content customizations
     * @request GET:/sites/{site_id}/pages/customized
     * @secure
     */
    pagesCustomizedDetail: (
      siteId: number,
      query: {
        variant: "enhancement" | "ai" | "schema" | "ai_instructions";
        "source[]"?: ("auto" | "manual" | "regenerate")[];
        q?: {
          id_eq?: number;
          status_eq?:
            | "pending"
            | "in_progress"
            | "failed"
            | "completed"
            | "ignored"
            | "incompatible"
            | "unreachable"
            | "noindex"
            | "duplicate"
            | "offsite"
            | "excluded";
          kind_eq?:
            | "unknown"
            | "unidentified"
            | "article"
            | "event"
            | "faq"
            | "organization"
            | "person"
            | "product"
            | "video"
            | "job"
            | "contact";
          path_eq?: string;
          query_eq?: string;
          path_and_query_eq?: string;
          page_recommendations_category_id_eq?: number;
          page_recommendations_page_id_eq?: number;
          recommendations_category_id_eq?: number;
          recommendations_active_eq?: boolean;
          recommendations_page_recommendations_category_id_eq?: number;
          recommendations_page_recommendations_page_id_eq?: number;
          /** When true, filters to pages with at least one outdated AI meta customization. Omit the parameter to disable the filter. */
          ai_customized_outdated?: true;
          /** When true, filters to pages with at least one outdated AI schema customization. Omit the parameter to disable the filter. */
          schema_customized_outdated?: true;
          /** When true, filters to pages with at least one outdated AI instructions (ai.md) customization. Omit the parameter to disable the filter. */
          ai_instructions_customized_outdated?: true;
        };
        /** @example "id ASC, status ASC, kind ASC, path ASC, query ASC, path_and_query ASC, depth ASC, lang ASC, widget_installed ASC, crawled_at ASC, page_recommendations_category_id ASC, page_recommendations_page_id ASC, recommendations_category_id ASC, recommendations_created_at ASC, recommendations_page_recommendations_category_id ASC, recommendations_page_recommendations_page_id ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PageCustomizationsResponse, Error>({
        path: `/sites/${siteId}/pages/customized`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Pages
     * @name PagesAutomatedDetail
     * @summary Retrieves a list of pages with On Page automations
     * @request GET:/sites/{site_id}/pages/automated
     * @secure
     */
    pagesAutomatedDetail: (
      siteId: number,
      query?: {
        q?: {
          id_eq?: number;
          status_eq?:
            | "pending"
            | "in_progress"
            | "failed"
            | "completed"
            | "ignored"
            | "incompatible"
            | "unreachable"
            | "noindex"
            | "duplicate"
            | "offsite"
            | "excluded";
          kind_eq?:
            | "unknown"
            | "unidentified"
            | "article"
            | "event"
            | "faq"
            | "organization"
            | "person"
            | "product"
            | "video"
            | "job"
            | "contact";
          path_eq?: string;
          query_eq?: string;
          path_and_query_eq?: string;
          page_recommendations_category_id_eq?: number;
          page_recommendations_page_id_eq?: number;
          recommendations_category_id_eq?: number;
          recommendations_active_eq?: boolean;
          recommendations_page_recommendations_category_id_eq?: number;
          recommendations_page_recommendations_page_id_eq?: number;
        };
        /** @example "id ASC, status ASC, kind ASC, path ASC, query ASC, path_and_query ASC, depth ASC, lang ASC, widget_installed ASC, crawled_at ASC, page_recommendations_category_id ASC, page_recommendations_page_id ASC, recommendations_category_id ASC, recommendations_created_at ASC, recommendations_page_recommendations_category_id ASC, recommendations_page_recommendations_page_id ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PageAutomationsResponse, any>({
        path: `/sites/${siteId}/pages/automated`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Pages
     * @name PagesBulkRecrawlCreate
     * @summary Recrawl Selected Pages
     * @request POST:/sites/{site_id}/pages/bulk_recrawl
     * @secure
     */
    pagesBulkRecrawlCreate: (
      siteId: number,
      data: PageBulkRecrawlAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/pages/bulk_recrawl`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Pages
     * @name PagesBulkIgnoreCreate
     * @summary Toggle Ignored Status on Selected Pages
     * @request POST:/sites/{site_id}/pages/bulk_ignore
     * @secure
     */
    pagesBulkIgnoreCreate: (
      siteId: number,
      data: PageBulkIgnoreAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/pages/bulk_ignore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Pages
     * @name PagesStatusesDetail
     * @summary Retrieves status statistics
     * @request GET:/sites/{site_id}/pages/statuses
     * @secure
     */
    pagesStatusesDetail: (
      siteId: number,
      query?: {
        q?: {
          id_eq?: number;
          status_eq?:
            | "pending"
            | "in_progress"
            | "failed"
            | "completed"
            | "ignored"
            | "incompatible"
            | "unreachable"
            | "noindex"
            | "duplicate"
            | "offsite"
            | "excluded";
          kind_eq?:
            | "unknown"
            | "unidentified"
            | "article"
            | "event"
            | "faq"
            | "organization"
            | "person"
            | "product"
            | "video"
            | "job"
            | "contact";
          path_eq?: string;
          query_eq?: string;
          path_and_query_eq?: string;
          page_recommendations_category_id_eq?: number;
          page_recommendations_page_id_eq?: number;
          recommendations_category_id_eq?: number;
          recommendations_active_eq?: boolean;
          recommendations_page_recommendations_category_id_eq?: number;
          recommendations_page_recommendations_page_id_eq?: number;
        };
        /** @example "id ASC, status ASC, kind ASC, path ASC, query ASC, path_and_query ASC, depth ASC, lang ASC, widget_installed ASC, crawled_at ASC, page_recommendations_category_id ASC, page_recommendations_page_id ASC, recommendations_category_id ASC, recommendations_created_at ASC, recommendations_page_recommendations_category_id ASC, recommendations_page_recommendations_page_id ASC" */
        s?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PageStatusStatsResponse, any>({
        path: `/sites/${siteId}/pages/statuses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Pages
     * @name PagesTypesDetail
     * @summary Retrieves status statistics
     * @request GET:/sites/{site_id}/pages/types
     * @secure
     */
    pagesTypesDetail: (
      siteId: number,
      query?: {
        q?: {
          id_eq?: number;
          status_eq?:
            | "pending"
            | "in_progress"
            | "failed"
            | "completed"
            | "ignored"
            | "incompatible"
            | "unreachable"
            | "noindex"
            | "duplicate"
            | "offsite"
            | "excluded";
          kind_eq?:
            | "unknown"
            | "unidentified"
            | "article"
            | "event"
            | "faq"
            | "organization"
            | "person"
            | "product"
            | "video"
            | "job"
            | "contact";
          path_eq?: string;
          query_eq?: string;
          path_and_query_eq?: string;
          page_recommendations_category_id_eq?: number;
          page_recommendations_page_id_eq?: number;
          recommendations_category_id_eq?: number;
          recommendations_active_eq?: boolean;
          recommendations_page_recommendations_category_id_eq?: number;
          recommendations_page_recommendations_page_id_eq?: number;
        };
        /** @example "id ASC, status ASC, kind ASC, path ASC, query ASC, path_and_query ASC, depth ASC, lang ASC, widget_installed ASC, crawled_at ASC, page_recommendations_category_id ASC, page_recommendations_page_id ASC, recommendations_category_id ASC, recommendations_created_at ASC, recommendations_page_recommendations_category_id ASC, recommendations_page_recommendations_page_id ASC" */
        s?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PageTypeStatsResponse, any>({
        path: `/sites/${siteId}/pages/types`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Pages
     * @name PagesRecrawlCreate
     * @summary Schedules Page Recrawl
     * @request POST:/sites/{site_id}/pages/{id}/recrawl
     * @secure
     */
    pagesRecrawlCreate: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/pages/${id}/recrawl`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Pages
     * @name PagesToggleIgnoreCreate
     * @summary Toggle Ignored Status
     * @request POST:/sites/{site_id}/pages/{id}/toggle_ignore
     * @secure
     */
    pagesToggleIgnoreCreate: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/pages/${id}/toggle_ignore`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Proxy Requests
     * @name ProxyRequestsDetail
     * @summary Retrieves proxy request logs
     * @request GET:/sites/{site_id}/proxy/requests
     * @secure
     */
    proxyRequestsDetail: (
      siteId: number,
      query?: {
        /**
         * Cursor: return older records before this UUIDv7
         * @format uuid
         */
        after?: string;
        /**
         * Cursor: return newer records after this UUIDv7
         * @format uuid
         */
        before?: string;
        q?: {
          level_eq?: "debug" | "info" | "warn" | "error";
          kind_eq?:
            | "unknown"
            | "page"
            | "stylesheet"
            | "script"
            | "image"
            | "font";
          status_eq?: number;
          verb_eq?:
            | "get"
            | "post"
            | "put"
            | "delete"
            | "patch"
            | "head"
            | "options"
            | "connect"
            | "trace";
          proxy_mode_eq?: "bypass" | "normal" | "test" | "edge";
          cache_eq?: "found" | "hit" | "miss" | "dynamic";
          region_eq?: "pdx" | "fra";
          port_eq?: number;
          bot_eq?: boolean;
          uri_eq?: string;
          client_ip_eq?: string;
          err_eq?: string;
          trace_eq?: string;
          waf_rule_eq?: number;
          waf_directive_eq?: number;
          waf_action_eq?: "log" | "allow" | "deny" | "detect";
          guard_action_eq?: "allow" | "deny" | "suspend" | "recover";
          guard_serial_eq?: number;
          /** @format date-time */
          created_at_gteq?: string;
          /** @format date-time */
          created_at_lteq?: string;
        };
        /** @example "id ASC, created_at ASC, status ASC, duration ASC" */
        s?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ProxyRequestsResponse, any>({
        path: `/sites/${siteId}/proxy/requests`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site Customization Actions
     * @name SiteCustomizationActionsDetail
     * @summary Retrieves Site Customization Actions
     * @request GET:/sites/{site_id}/site_customization_actions
     * @secure
     */
    siteCustomizationActionsDetail: (
      siteId: number,
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
        q?: {
          status_eq?:
            | "pending"
            | "in_progress"
            | "completed"
            | "failed"
            | "aborted";
          /** @format date-time */
          created_at_gteq?: string;
          /** @format date-time */
          created_at_lteq?: string;
          with_variants?: ("title" | "description" | "schema" | "summary")[];
        };
        /** @example "status ASC, created_at ASC" */
        s?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SiteCustomizationActionsResponse, any>({
        path: `/sites/${siteId}/site_customization_actions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site Customization Actions
     * @name SiteCustomizationActionsCreate
     * @summary Creates Site Customization Action
     * @request POST:/sites/{site_id}/site_customization_actions
     * @secure
     */
    siteCustomizationActionsCreate: (
      siteId: number,
      data: SiteCustomizationActionAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<SiteCustomizationActionResponse, void>({
        path: `/sites/${siteId}/site_customization_actions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site Customization Actions
     * @name SiteCustomizationActionsAbortCreate
     * @summary Aborts Site Customization Action
     * @request POST:/sites/{site_id}/site_customization_actions/{id}/abort
     * @secure
     */
    siteCustomizationActionsAbortCreate: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<SiteCustomizationActionResponse, void>({
        path: `/sites/${siteId}/site_customization_actions/${id}/abort`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Dashboards
     * @name DashboardsDetail
     * @summary Retrieves Site Dashboards
     * @request GET:/sites/{site_id}/dashboards
     * @secure
     */
    dashboardsDetail: (
      siteId: number,
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SiteDashboardsResponse, any>({
        path: `/sites/${siteId}/dashboards`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Dashboards
     * @name DashboardsCreate
     * @summary Creates a Site Dashboard
     * @request POST:/sites/{site_id}/dashboards
     * @secure
     */
    dashboardsCreate: (
      siteId: number,
      data: SiteDashboardAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/sites/${siteId}/dashboards`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Dashboards
     * @name DashboardsDetail2
     * @summary Retrieves a Site Dashboard
     * @request GET:/sites/{site_id}/dashboards/{id}
     * @originalName dashboardsDetail
     * @duplicate
     * @secure
     */
    dashboardsDetail2: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<SiteDashboardResponse, any>({
        path: `/sites/${siteId}/dashboards/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Dashboards
     * @name DashboardsPartialUpdate
     * @summary Updates a Site Dashboard
     * @request PATCH:/sites/{site_id}/dashboards/{id}
     * @secure
     */
    dashboardsPartialUpdate: (
      siteId: number,
      id: number,
      data: SiteDashboardAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/sites/${siteId}/dashboards/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Dashboards
     * @name DashboardsDelete
     * @summary Deletes a Site Dashboard
     * @request DELETE:/sites/{site_id}/dashboards/{id}
     * @secure
     */
    dashboardsDelete: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/sites/${siteId}/dashboards/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Dashboards
     * @name DashboardsViewDetail
     * @summary Retrieves Dashboard Data
     * @request GET:/sites/{site_id}/dashboards/{id}/view
     * @secure
     */
    dashboardsViewDetail: (
      siteId: number,
      id: number,
      query?: {
        start_date?: string;
        end_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SiteDashboardViewResponse, any>({
        path: `/sites/${siteId}/dashboards/${id}/view`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site Errors
     * @name ErrorsTimeSeriesDetail
     * @summary Retrieves Error Series
     * @request GET:/sites/{site_id}/errors/time_series
     * @secure
     */
    errorsTimeSeriesDetail: (
      siteId: number,
      query?: {
        from?: number;
        to?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SiteErrorTimeSeriesResponse, any>({
        path: `/sites/${siteId}/errors/time_series`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site Errors
     * @name ErrorsBreakdownDetail
     * @summary Retrieves Error Breakdown
     * @request GET:/sites/{site_id}/errors/breakdown
     * @secure
     */
    errorsBreakdownDetail: (
      siteId: number,
      query?: {
        from?: number;
        to?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SiteErrorBreakdownResponse, any>({
        path: `/sites/${siteId}/errors/breakdown`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Integrations
     * @name IntegrationsDetail
     * @summary Retrieves Integrations
     * @request GET:/sites/{site_id}/integrations
     * @secure
     */
    integrationsDetail: (
      siteId: number,
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SiteIntegrationsResponse, any>({
        path: `/sites/${siteId}/integrations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Integrations
     * @name IntegrationsCreate
     * @summary Creates an Integration
     * @request POST:/sites/{site_id}/integrations
     * @secure
     */
    integrationsCreate: (
      siteId: number,
      data: SiteIntegrationAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<SiteIntegrationResponse, Error>({
        path: `/sites/${siteId}/integrations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Integrations
     * @name IntegrationsDetail2
     * @summary Retrieves an Integration
     * @request GET:/sites/{site_id}/integrations/{id}
     * @originalName integrationsDetail
     * @duplicate
     * @secure
     */
    integrationsDetail2: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<SiteIntegrationResponse, any>({
        path: `/sites/${siteId}/integrations/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Integrations
     * @name IntegrationsPartialUpdate
     * @summary Updates an Integration
     * @request PATCH:/sites/{site_id}/integrations/{id}
     * @secure
     */
    integrationsPartialUpdate: (
      siteId: number,
      id: number,
      data: SiteIntegrationAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/sites/${siteId}/integrations/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Integrations
     * @name IntegrationsDelete
     * @summary Deletes an Integration
     * @request DELETE:/sites/{site_id}/integrations/{id}
     * @secure
     */
    integrationsDelete: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/sites/${siteId}/integrations/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Integrations
     * @name IntegrationsConfigurationDetail
     * @summary Retrieves an Integration
     * @request GET:/sites/{site_id}/integrations/{id}/configuration
     * @secure
     */
    integrationsConfigurationDetail: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<SiteIntegrationConfigurationResponse, Error>({
        path: `/sites/${siteId}/integrations/${id}/configuration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site Performance Reports
     * @name PerformanceReportsDetail
     * @summary Retrieves Site Performance Reports (one row per platform)
     * @request GET:/sites/{site_id}/performance_reports
     * @secure
     */
    performanceReportsDetail: (siteId: number, params: RequestParams = {}) =>
      this.http.request<SitePerformanceReportsResponse, any>({
        path: `/sites/${siteId}/performance_reports`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site Visibility Reports
     * @name VisibilityReportsDetail
     * @summary Retrieves Site Visibility Reports (one row per platform)
     * @request GET:/sites/{site_id}/visibility_reports
     * @secure
     */
    visibilityReportsDetail: (siteId: number, params: RequestParams = {}) =>
      this.http.request<SiteVisibilityReportsResponse, any>({
        path: `/sites/${siteId}/visibility_reports`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site Visitors
     * @name VisitorsBreakdownDetail
     * @summary Retrieves Visitor Breakdown
     * @request GET:/sites/{site_id}/visitors/breakdown
     * @secure
     */
    visitorsBreakdownDetail: (
      siteId: number,
      query?: {
        from?: number;
        to?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SiteVisitorBreakdownResponse, any>({
        path: `/sites/${siteId}/visitors/breakdown`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site Visits
     * @name VisitsTimeSeriesDetail
     * @summary Retrieves Visits Series
     * @request GET:/sites/{site_id}/visits/time_series
     * @secure
     */
    visitsTimeSeriesDetail: (
      siteId: number,
      query?: {
        from?: number;
        to?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SiteVisitTimeSeriesResponse, any>({
        path: `/sites/${siteId}/visits/time_series`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site WAF Directives
     * @name WafDirectivesDetail
     * @summary Retrieves WAF Directives
     * @request GET:/sites/{site_id}/waf_directives
     * @secure
     */
    wafDirectivesDetail: (
      siteId: number,
      query?: {
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SiteWafDirectivesResponse, any>({
        path: `/sites/${siteId}/waf_directives`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site WAF Directives
     * @name WafDirectivesCreate
     * @summary Creates WAF Directive
     * @request POST:/sites/{site_id}/waf_directives
     * @secure
     */
    wafDirectivesCreate: (
      siteId: number,
      data: SiteWafDirectiveAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<SiteWafDirectiveResponse, void>({
        path: `/sites/${siteId}/waf_directives`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site WAF Directives
     * @name WafDirectivesDetail2
     * @summary Retrieves WAF Directive
     * @request GET:/sites/{site_id}/waf_directives/{id}
     * @originalName wafDirectivesDetail
     * @duplicate
     * @secure
     */
    wafDirectivesDetail2: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<SiteWafDirectiveResponse, any>({
        path: `/sites/${siteId}/waf_directives/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site WAF Directives
     * @name WafDirectivesPartialUpdate
     * @summary Updates WAF Directive
     * @request PATCH:/sites/{site_id}/waf_directives/{id}
     * @secure
     */
    wafDirectivesPartialUpdate: (
      siteId: number,
      id: number,
      data: SiteWafDirectiveAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/sites/${siteId}/waf_directives/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site WAF Directives
     * @name WafDirectivesDelete
     * @summary Deletes WAF Directive
     * @request DELETE:/sites/{site_id}/waf_directives/{id}
     * @secure
     */
    wafDirectivesDelete: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/sites/${siteId}/waf_directives/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site WAF Events
     * @name WafEventsTimeSeriesDetail
     * @summary Retrieves WAF Series
     * @request GET:/sites/{site_id}/waf_events/time_series
     * @secure
     */
    wafEventsTimeSeriesDetail: (
      siteId: number,
      query?: {
        from?: number;
        to?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SiteWafTimeSeriesResponse, any>({
        path: `/sites/${siteId}/waf_events/time_series`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site WAF Events
     * @name WafEventsBreakdownDetail
     * @summary Retrieves WAF Breakdown
     * @request GET:/sites/{site_id}/waf_events/breakdown
     * @secure
     */
    wafEventsBreakdownDetail: (
      siteId: number,
      query?: {
        from?: number;
        to?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SiteWafBreakdownResponse, any>({
        path: `/sites/${siteId}/waf_events/breakdown`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name SitesList
     * @summary Retrieves Sites
     * @request GET:/sites
     * @secure
     */
    sitesList: (
      query?: {
        q?: {
          name_eq?: string;
          crawl_status_eq?:
            | "unknown"
            | "in_progress"
            | "failed"
            | "finished"
            | "analysing"
            | "completed"
            | "aborted";
        };
        /** @example "crawl_status ASC, crawled_at ASC, created_at ASC" */
        s?: string;
        domain_id?: number;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SitesResponse, any>({
        path: `/sites`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name SitesCreate
     * @summary Creates Site
     * @request POST:/sites
     * @secure
     */
    sitesCreate: (data: SiteCreateAttributes, params: RequestParams = {}) =>
      this.http.request<SiteResponse, any>({
        path: `/sites`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name RegionsList
     * @summary Retrieves Regions
     * @request GET:/sites/regions
     * @secure
     */
    regionsList: (params: RequestParams = {}) =>
      this.http.request<RegionsResponse, any>({
        path: `/sites/regions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name LanguagesList
     * @summary Retrieves Regions
     * @request GET:/sites/languages
     * @secure
     */
    languagesList: (params: RequestParams = {}) =>
      this.http.request<LanguagesResponse, any>({
        path: `/sites/languages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name SitesDetail
     * @summary Retrieves Site
     * @request GET:/sites/{id}
     * @secure
     */
    sitesDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<SiteResponse, any>({
        path: `/sites/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name SitesPartialUpdate
     * @summary Updates Site
     * @request PATCH:/sites/{id}
     * @secure
     */
    sitesPartialUpdate: (
      id: number,
      data: SiteUpdateAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/sites/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name SitesDelete
     * @summary Deletes Site
     * @request DELETE:/sites/{id}
     * @secure
     */
    sitesDelete: (id: number, params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/sites/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name GoalsDetail
     * @summary Retrieves Site Goals
     * @request GET:/sites/{id}/goals
     * @secure
     */
    goalsDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<SiteGoalsResponse, any>({
        path: `/sites/${id}/goals`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name DailyGoalsDetail
     * @summary Retrieves Site Daily Goals
     * @request GET:/sites/{id}/daily_goals
     * @secure
     */
    dailyGoalsDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<SiteDailyGoalsResponse, any>({
        path: `/sites/${id}/daily_goals`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name StatsDetail
     * @summary Retrieves Site Stats
     * @request GET:/sites/{id}/stats
     * @secure
     */
    statsDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<SiteStatsResponse, any>({
        path: `/sites/${id}/stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name WidgetDetail
     * @summary Retrieves Site Widget
     * @request GET:/sites/{id}/widget
     * @secure
     */
    widgetDetail: (id: number, params: RequestParams = {}) =>
      this.http.request<SiteWidgetResponse, any>({
        path: `/sites/${id}/widget`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name CrawlCreate
     * @summary Soft Recrawl
     * @request POST:/sites/{id}/crawl
     * @secure
     */
    crawlCreate: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/sites/${id}/crawl`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name RecrawlCreate
     * @summary Forced Recrawl
     * @request POST:/sites/{id}/recrawl
     * @secure
     */
    recrawlCreate: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/sites/${id}/recrawl`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name AbortCrawlCreate
     * @summary Abort Crawler
     * @request POST:/sites/{id}/abort_crawl
     * @secure
     */
    abortCrawlCreate: (id: number, params: RequestParams = {}) =>
      this.http.request<void, Error>({
        path: `/sites/${id}/abort_crawl`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name WidgetTestCreate
     * @summary Abort Crawler
     * @request POST:/sites/{id}/widget_test
     * @secure
     */
    widgetTestCreate: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/sites/${id}/widget_test`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name WidgetToggleCreate
     * @summary Abort Crawler
     * @request POST:/sites/{id}/widget_toggle
     * @secure
     */
    widgetToggleCreate: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/sites/${id}/widget_toggle`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name DeveloperInstructionsCreate
     * @summary Send Instructions to Developer
     * @request POST:/sites/{id}/developer_instructions
     * @secure
     */
    developerInstructionsCreate: (
      id: number,
      data: SiteDeveloperInstructions,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/sites/${id}/developer_instructions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites
     * @name SiteSpeedApplyCreate
     * @summary Apply for Site Speed
     * @request POST:/sites/{id}/site_speed_apply
     * @secure
     */
    siteSpeedApplyCreate: (id: number, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/sites/${id}/site_speed_apply`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Links
     * @name TasksDetail
     * @summary Retrieves Site Links
     * @request GET:/sites/{site_id}/tasks
     * @secure
     */
    tasksDetail: (
      siteId: number,
      query?: {
        q?: {
          status_eq?: "TODO" | "DOING" | "DONE" | "CANCELLED";
          type_eq?: "BrandLink" | "NicheLink" | "OutreachLink" | "LLMCitation";
          link_domain_eq?: string;
          link_title_eq?: string;
          category_eq?: string;
          keyword_name_eq?: string;
          keyword_language_eq?: string;
          keyword_country_eq?: string;
          /** @format float */
          keyword_alli_score_eq?: number;
          /** @format double */
          keyword_alli_rating_eq?: number;
          keyword_start_pos_eq?: number;
          keyword_now_pos_eq?: number;
          /** @format float */
          keyword_cpc_eq?: number;
          /** @format float */
          keyword_cmp_eq?: number;
          keyword_search_vol_eq?: number;
          keyword_day_change_eq?: number;
          keyword_week_change_eq?: number;
          keyword_month_change_eq?: number;
          keyword_life_change_eq?: number;
        };
        /** @example "site_id ASC, keyword_id ASC, status ASC, type ASC, created_at ASC, link_domain ASC, link_title ASC, category ASC, probability ASC, reddit_first ASC, keyword_name ASC, keyword_language ASC, keyword_country ASC, keyword_alli_score ASC, keyword_alli_rating ASC, keyword_start_pos ASC, keyword_now_pos ASC, keyword_cpc ASC, keyword_cmp ASC, keyword_search_vol ASC, keyword_day_change ASC, keyword_week_change ASC, keyword_month_change ASC, keyword_life_change ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<TasksResponse, any>({
        path: `/sites/${siteId}/tasks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Links
     * @name TasksDetail2
     * @summary Retrieves Site Link
     * @request GET:/sites/{site_id}/tasks/{id}
     * @originalName tasksDetail
     * @duplicate
     * @secure
     */
    tasksDetail2: (siteId: number, id: number, params: RequestParams = {}) =>
      this.http.request<TaskResponse, any>({
        path: `/sites/${siteId}/tasks/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Links
     * @name TasksPartialUpdate
     * @summary Update Site Link
     * @request PATCH:/sites/{site_id}/tasks/{id}
     * @secure
     */
    tasksPartialUpdate: (
      siteId: number,
      id: number,
      data: TaskAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/sites/${siteId}/tasks/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sites / Links
     * @name TasksCancelCreate
     * @summary Cancel Site Link
     * @request POST:/sites/{site_id}/tasks/{id}/cancel
     * @secure
     */
    tasksCancelCreate: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/sites/${siteId}/tasks/${id}/cancel`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Categories
     * @name WidgetCategoriesStatsDetail
     * @summary Retrieves Site Recommendation Categories Stats
     * @request GET:/sites/{site_id}/widget/categories/stats
     * @secure
     */
    widgetCategoriesStatsDetail: (siteId: number, params: RequestParams = {}) =>
      this.http.request<WidgetCategoriesStatsResponse, any>({
        path: `/sites/${siteId}/widget/categories/stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Categories
     * @name PagesWidgetCategoriesStatsDetail
     * @summary Retrieves Page Recommendation Categories Stats
     * @request GET:/sites/{site_id}/pages/{page_id}/widget/categories/stats
     * @secure
     */
    pagesWidgetCategoriesStatsDetail: (
      siteId: number,
      pageId: number,
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetCategoriesStatsResponse, any>({
        path: `/sites/${siteId}/pages/${pageId}/widget/categories/stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / CustomizationActions
     * @name WidgetCustomizationActionsDetail
     * @summary Retrieves Site CustomizationActions
     * @request GET:/sites/{site_id}/widget/customization_actions
     * @secure
     */
    widgetCustomizationActionsDetail: (
      siteId: number,
      query?: {
        q?: {
          status_eq?: "pending" | "completed" | "failed";
          kind_eq?: "approve" | "unapprove";
          variant_eq?: "ai" | "schema" | "enhancement" | "ai_instructions";
        };
        /** @example "id ASC, created_at ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetCustomizationActionsResponse, any>({
        path: `/sites/${siteId}/widget/customization_actions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / CustomizationActions
     * @name WidgetCustomizationActionsCreate
     * @summary Creates CustomizationAction
     * @request POST:/sites/{site_id}/widget/customization_actions
     * @secure
     */
    widgetCustomizationActionsCreate: (
      siteId: number,
      data: WidgetCustomizationActionCreateAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetCustomizationActionResponse, Error>({
        path: `/sites/${siteId}/widget/customization_actions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / CustomizationActions
     * @name WidgetCustomizationActionsDetail2
     * @summary Retrieves Site CustomizationAction
     * @request GET:/sites/{site_id}/widget/customization_actions/{id}
     * @originalName widgetCustomizationActionsDetail
     * @duplicate
     * @secure
     */
    widgetCustomizationActionsDetail2: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetCustomizationActionResponse, Error>({
        path: `/sites/${siteId}/widget/customization_actions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Customizations
     * @name WidgetCustomizationsDetail
     * @summary Retrieves Individual Customization
     * @request GET:/sites/{site_id}/widget/customizations/{id}
     * @secure
     */
    widgetCustomizationsDetail: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetCustomizationResponse, any>({
        path: `/sites/${siteId}/widget/customizations/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Customizations
     * @name WidgetCustomizationsPartialUpdate
     * @summary Updates Individual Customization
     * @request PATCH:/sites/{site_id}/widget/customizations/{id}
     * @secure
     */
    widgetCustomizationsPartialUpdate: (
      siteId: number,
      id: number,
      data: WidgetCustomizationAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/sites/${siteId}/widget/customizations/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Customizations
     * @name WidgetCustomizationsDelete
     * @summary Destroys a Customization
     * @request DELETE:/sites/{site_id}/widget/customizations/{id}
     * @secure
     */
    widgetCustomizationsDelete: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/widget/customizations/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Customizations
     * @name WidgetCustomizationsDetail2
     * @summary Retrieves Global Customizations
     * @request GET:/sites/{site_id}/widget/customizations/{variant}
     * @originalName widgetCustomizationsDetail
     * @duplicate
     * @secure
     */
    widgetCustomizationsDetail2: (
      siteId: number,
      variant: "enhancement" | "ai" | "schema",
      query?: {
        q?: {
          outdated_eq?: boolean;
          source_eq?: "auto" | "manual" | "regenerate";
        };
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetCustomizationsResponse, any>({
        path: `/sites/${siteId}/widget/customizations/${variant}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Customizations
     * @name WidgetCustomizationsStatsDetail
     * @summary Retrieves Customizations Stats
     * @request GET:/sites/{site_id}/widget/customizations/{variant}/stats
     * @secure
     */
    widgetCustomizationsStatsDetail: (
      siteId: number,
      variant: "enhancement" | "ai" | "schema",
      query?: {
        "source[]"?: ("auto" | "manual" | "regenerate")[];
        outdated?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetCustomizationStatsResponse, Error>({
        path: `/sites/${siteId}/widget/customizations/${variant}/stats`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Customizations
     * @name WidgetCustomizationsAiInstructionsStatsDetail
     * @summary Retrieves AI Instructions Customizations Stats
     * @request GET:/sites/{site_id}/widget/customizations/ai_instructions/stats
     * @secure
     */
    widgetCustomizationsAiInstructionsStatsDetail: (
      siteId: number,
      query?: {
        "source[]"?: ("auto" | "regenerate")[];
        outdated?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetCustomizationStatsResponse, any>({
        path: `/sites/${siteId}/widget/customizations/ai_instructions/stats`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Customizations
     * @name PagesWidgetCustomizationsAiInstructionsDetail
     * @summary Retrieves Page AI Instructions Customizations
     * @request GET:/sites/{site_id}/pages/{page_id}/widget/customizations/ai_instructions
     * @secure
     */
    pagesWidgetCustomizationsAiInstructionsDetail: (
      siteId: number,
      pageId: number,
      query?: {
        q?: {
          outdated_eq?: boolean;
          source_eq?: "auto" | "regenerate";
        };
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetCustomizationsResponse, any>({
        path: `/sites/${siteId}/pages/${pageId}/widget/customizations/ai_instructions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Customizations
     * @name PagesWidgetCustomizationsDetail
     * @summary Retrieves Page Customizations
     * @request GET:/sites/{site_id}/pages/{page_id}/widget/customizations/{variant}
     * @secure
     */
    pagesWidgetCustomizationsDetail: (
      siteId: number,
      pageId: number,
      variant: "enhancement" | "ai" | "schema",
      query?: {
        q?: {
          outdated_eq?: boolean;
          source_eq?: "auto" | "manual" | "regenerate";
        };
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetCustomizationsResponse, any>({
        path: `/sites/${siteId}/pages/${pageId}/widget/customizations/${variant}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Customizations
     * @name PagesWidgetCustomizationsGenerateTitleCreate
     * @summary Generates Title Customization
     * @request POST:/sites/{site_id}/pages/{page_id}/widget/customizations/{id}/generate_title
     * @secure
     */
    pagesWidgetCustomizationsGenerateTitleCreate: (
      siteId: number,
      pageId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/pages/${pageId}/widget/customizations/${id}/generate_title`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Customizations
     * @name PagesWidgetCustomizationsGenerateDescriptionCreate
     * @summary Generates Description Customization
     * @request POST:/sites/{site_id}/pages/{page_id}/widget/customizations/{id}/generate_description
     * @secure
     */
    pagesWidgetCustomizationsGenerateDescriptionCreate: (
      siteId: number,
      pageId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/pages/${pageId}/widget/customizations/${id}/generate_description`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Customizations
     * @name PagesWidgetCustomizationsGenerateSchemaCreate
     * @summary Generates Schema Customization
     * @request POST:/sites/{site_id}/pages/{page_id}/widget/customizations/{id}/generate_schema
     * @secure
     */
    pagesWidgetCustomizationsGenerateSchemaCreate: (
      siteId: number,
      pageId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/pages/${pageId}/widget/customizations/${id}/generate_schema`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Customizations
     * @name PagesWidgetCustomizationsGenerateAiInstructionsCreate
     * @summary Generates AI Instructions Customization
     * @request POST:/sites/{site_id}/pages/{page_id}/widget/customizations/{id}/generate_ai_instructions
     * @secure
     */
    pagesWidgetCustomizationsGenerateAiInstructionsCreate: (
      siteId: number,
      pageId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/sites/${siteId}/pages/${pageId}/widget/customizations/${id}/generate_ai_instructions`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / RecommendationActions
     * @name WidgetRecommendationActionsDetail
     * @summary Retrieves Site RecommendationActions
     * @request GET:/sites/{site_id}/widget/recommendation_actions
     * @secure
     */
    widgetRecommendationActionsDetail: (
      siteId: number,
      query?: {
        q?: {
          status_eq?: "pending" | "completed" | "failed";
          kind_eq?: "approve" | "unapprove";
          variant_eq?: "automation" | "interlink";
          category_id_eq?: number;
        };
        /** @example "id ASC, created_at ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetRecommendationActionsResponse, any>({
        path: `/sites/${siteId}/widget/recommendation_actions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / RecommendationActions
     * @name WidgetRecommendationActionsCreate
     * @summary Creates RecommendationAction
     * @request POST:/sites/{site_id}/widget/recommendation_actions
     * @secure
     */
    widgetRecommendationActionsCreate: (
      siteId: number,
      data: WidgetRecommendationActionCreateAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetRecommendationActionResponse, Error>({
        path: `/sites/${siteId}/widget/recommendation_actions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / RecommendationActions
     * @name WidgetRecommendationActionsDetail2
     * @summary Retrieves Site RecommendationAction
     * @request GET:/sites/{site_id}/widget/recommendation_actions/{id}
     * @originalName widgetRecommendationActionsDetail
     * @duplicate
     * @secure
     */
    widgetRecommendationActionsDetail2: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetRecommendationActionResponse, Error>({
        path: `/sites/${siteId}/widget/recommendation_actions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Recommendations
     * @name WidgetRecommendationsDetail
     * @summary Retrieves Individual Recommendation
     * @request GET:/sites/{site_id}/widget/recommendations/{id}
     * @secure
     */
    widgetRecommendationsDetail: (
      siteId: number,
      id: number,
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetRecommendationResponse, any>({
        path: `/sites/${siteId}/widget/recommendations/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Recommendations
     * @name WidgetRecommendationsPartialUpdate
     * @summary Updates Individual Recommendation
     * @request PATCH:/sites/{site_id}/widget/recommendations/{id}
     * @secure
     */
    widgetRecommendationsPartialUpdate: (
      siteId: number,
      id: number,
      data: WidgetRecommendationAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/sites/${siteId}/widget/recommendations/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Recommendations
     * @name WidgetRecommendationsDetail2
     * @summary Retrieves Page Recommendations
     * @request GET:/sites/{site_id}/widget/recommendations
     * @originalName widgetRecommendationsDetail
     * @duplicate
     * @secure
     */
    widgetRecommendationsDetail2: (
      siteId: number,
      query?: {
        q?: {
          category_id_eq?: number;
          active_eq?: boolean;
          page_recommendations_category_id_eq?: number;
          page_recommendations_page_id_eq?: number;
        };
        /** @example "category_id ASC, created_at ASC, page_recommendations_category_id ASC, page_recommendations_page_id ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetRecommendationsResponse, any>({
        path: `/sites/${siteId}/widget/recommendations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Widget / Recommendations
     * @name PagesWidgetRecommendationsDetail
     * @summary Retrieves Page Recommendations
     * @request GET:/sites/{site_id}/pages/{page_id}/widget/recommendations
     * @secure
     */
    pagesWidgetRecommendationsDetail: (
      siteId: number,
      pageId: number,
      query?: {
        q?: {
          category_id_eq?: number;
          active_eq?: boolean;
          page_recommendations_category_id_eq?: number;
          page_recommendations_page_id_eq?: number;
        };
        /** @example "category_id ASC, created_at ASC, page_recommendations_category_id ASC, page_recommendations_page_id ASC" */
        s?: string;
        "page[number]"?: number;
        /** @default 10 */
        "page[size]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<WidgetRecommendationsResponse, any>({
        path: `/sites/${siteId}/pages/${pageId}/widget/recommendations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tenant = {
    /**
     * No description
     *
     * @tags Tenant / Accounts
     * @name AccountList
     * @summary Retrieves Account
     * @request GET:/tenant/account
     * @secure
     */
    accountList: (params: RequestParams = {}) =>
      this.http.request<TenantAccountResponse, Error>({
        path: `/tenant/account`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant / Accounts
     * @name AccountCreate
     * @summary Creates Account
     * @request POST:/tenant/account
     * @secure
     */
    accountCreate: (
      data: TenantAccountAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/tenant/account`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant / Accounts
     * @name AccountPartialUpdate
     * @summary Updates Account
     * @request PATCH:/tenant/account
     * @secure
     */
    accountPartialUpdate: (
      data: TenantAccountAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/tenant/account`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant / Accounts
     * @name AccountDelete
     * @summary Deletes Account
     * @request DELETE:/tenant/account
     * @secure
     */
    accountDelete: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/tenant/account`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant / Hostnames
     * @name AccountHostnamesList
     * @summary Retrieves Account Hostnames
     * @request GET:/tenant/account/hostnames
     * @secure
     */
    accountHostnamesList: (params: RequestParams = {}) =>
      this.http.request<TenantHostnamesResponse, Error>({
        path: `/tenant/account/hostnames`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant / Hostnames
     * @name AccountHostnamesCreate
     * @summary Creates Hostname
     * @request POST:/tenant/account/hostnames
     * @secure
     */
    accountHostnamesCreate: (
      data: TenantHostnameAttributes,
      params: RequestParams = {},
    ) =>
      this.http.request<void, Error>({
        path: `/tenant/account/hostnames`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant / Hostnames
     * @name AccountHostnamesDelete
     * @summary Deletes Hostname
     * @request DELETE:/tenant/account/hostnames/{id}
     * @secure
     */
    accountHostnamesDelete: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/tenant/account/hostnames/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  widget = {
    /**
     * No description
     *
     * @tags Widget / Categories
     * @name CategoriesList
     * @summary Retrieves all available Recommendation Categories
     * @request GET:/widget/categories
     * @secure
     */
    categoriesList: (params: RequestParams = {}) =>
      this.http.request<WidgetCategoriesResponse, any>({
        path: `/widget/categories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
